var THREE;
try {
  if (window) {
    THREE = require("three");
  }
} catch (e) {}

// PLAYER OBJECT:
function Player(id, manager, UTILS, config, game) {
  // VALS:
  this.id = id;
  this.sentTo = [];
  this.inputs = [];
  this.spins = [];
  this.stateHistory = [];
  this.weaponMeshes = [];
  this.weaponGeos = {};
  this.legMeshes = [];
  this.armMeshes = [];
  this.lastInput = [];
  this.lastDeltas = [];
  this.reloads = [];
  this.ammos = [];
  this.ping = 0;
  this.pings = [];
  this.avgSpn = 0;
  this.score = 0;
  this.scoreObjs = {};
  this.checkPoint = null;
  this.checkPointList = [];
  this.killList = [];
  this.lstDrs = [];
  this.convs = 0;
  this.timer = null;
  this.gameTimer = null;
  this.kills = 0;
  this.deaths = 0;
  this.assists = 0;
  this.melees = 0;
  this.setbacks = 0;
  this.caps = 0;
  this.deathStreak = 0;
  this.level = 0;
  this.lives = game.waitTimers && game.config ? game.config.lives || 0 : 0;
  this.deltaAdd = 0;
  this.deltaDiv = 1;
  this.sprayIndex = 0;
  this.hatIndex = -1;
  this.backIndex = -1;
  this.meleeIndex = -1;
  this.lastSpray = 0;
  this.lastPickup = 0;
  this.lastPicked = [];
  this.playTime = 0;
  this.hackSus = 0;
  this.lastCheck = 0;
  this.sCount = 0;
  this.streaks = {};
  var tmpObj;

  // INIT:
  this.init = function (x, y, z, name, isYou, isHacker) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.stepSrc = null;
    this.name = name || "unknown";
    this.xVel = 0;
    this.yVel = 0;
    this.zVel = 0;
    this.hackSus--;
    if (this.hackSus < 0) {
      this.hackSus = 0;
    }
    this.renderMinimal = false;
    this.spins.length = 0;
    this.noMovTimer = 0;
    this.xDire = 0;
    this.yDire = 0;
    this.hitTimer = 0;
    this.ticker = 0;
    this.spread = 0;
    this.spreadPlus = 0;
    this.aimVal = 1;
    this.aimDir = 0;
    this.aimTime = 0;
    this.streak = 0;
    this.killStreak = 0;
    this.lastKill = 0;
    this.stateHistory.length = 0;
    this.lastInput.length = 0;
    this.swapTweenA = 0;
    this.dmgReceived = {};
    this.landBobY = 0;
    this.landBobYR = 0;
    this.jumpBobY = 0;
    this.slideTimer = 0;
    this.canSlide = true;
    this.leanAnimX = 0;
    this.leanAnimY = 0;
    this.leanAnimZ = 0;
    this.bobAnimZ = 0;
    this.bobAnimY = 0;
    this.idleAnim = 0;
    this.inspecting = false;
    this.inspectX = false;
    this.stepVal = 0;
    this.stepChase = 0;
    this.stepDir = 1;
    this.stepDirR = 1;
    this.reward = 0;
    this.recoilAnim = 0;
    this.recoilAnimY = 0;
    this.recoilForce = 0;
    this.recoilTweenY = 0;
    this.recoilTweenYM = 0;
    this.recoilTweenZ = 0;
    this.jumpRot = 0;
    this.jumpRotM = 0;
    this.recoilX = 0;
    this.recoilZ = 0;
    this.crouchVal = 0;
    this.onGround = true;
    this.onLadder = false;
    this.terrainSlipping = false;
    this.rampFix = null;
    this.didJump = false;
    this.jumpCooldown = 0;
    this.didShoot = false;
    this.lodActive = false;
    this.locked = false;
    this.latestData = false;
    this.airTime = 0;
    this.height = config.playerHeight;
    this.headScale = config.cameraHeight;
    this.scale = config.playerScale;
    this.active = true;
    this.interpolate = false;
    this.isYou = isYou;
    this.sentTo.length = 0;
    this.inputSN = 0;
    this.inputs.length = 0;
    this.weaponIndex = 0;
    this.swapTime = 0;
    this.recon = false;
    this.inView = false;
    this.meleeAnim = {};
    this.isHacker = isHacker;
    this.customLoadout = null;
    this.lastCheck = game.now;
    this.lastPicked.length = 0;
  };

  // SET CLASS:
  this.setClass = function (game, index, secIndex, skip) {
    if (!skip) {
      if (game.config && game.config.classes.indexOf(index) < 0) {
        if (index != game.config.classes[0]) {
          this.skins = [-1, -1];
        }
        index = game.config.classes[0];
      }
      if (game.mode) {
        if (game.mode.noWeap) {
          index = 9;
        }
        if (game.mode.teamClass && game.mode.teamClass[this.team]) {
          index = game.mode.teamClass[this.team];
          this.skins = [-1, -1];
        }
      }
    }
    if (index == undefined || index == null) {
      index = game.classes.length - 1;
    }
    this.classIndex = index;
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.loadout = [game.classes[index].loadout[0]];
    if (!game.classes[index].secondary) {
      this.secIndex = null;
    } else {
      if (UTILS.isNumber(secIndex)) {
        this.loadout.push(secIndex);
      }
    }
    if (this.loadout.indexOf(12) < 0) {
      this.loadout.push(12);
    }
    this.speed = game.classes[index].speed || 1;
    for (var i = 0; i < this.loadout.length; ++i) {
      this.reloads.push(0);
      this.ammos.push(game.weapons[this.loadout[i]].ammo);
    }
    this.reloadTimer = 0;
    this.regenDelay = game.classes[index].regenDelay || config.regenDelay;
    this.maxHealth = game.classes[index].health * (game.config ? game.config.healthMlt || 1 : 1);
    this.health = this.maxHealth;
    this.hpChase = this.health;
    this.regen = game.mode && game.mode.noRegen ? 0 : game.classes[index].regen || config.regenVal;
  };

  // UPDATE LOADOUT:
  this.updateLoadout = function (game, wepIndex, regen = true, index, secIndex) {
    this.weaponIndex = wepIndex;
    this.reloads.length = 0;
    this.ammos.length = 0;
    this.loadout = [index];
    this.skins = [-1, -1];
    if (UTILS.isNumber(secIndex)) {
      this.loadout.push(secIndex);
    }
    if (UTILS.isNumber(secIndex)) {
      this.secIndex = secIndex;
    }
    if (this.loadout.indexOf(12) < 0) {
      this.loadout.push(12);
    }
    for (var i = 0; i < this.loadout.length; ++i) {
      this.reloads.push(0);
      this.ammos.push(game.weapons[this.loadout[i]].ammo);
    }
    this.customLoadout = [...this.loadout];
    if (regen) {
      manager.regenMeshes(this);
    }
  };

  // RESET INPUTS:
  this.resetInputs = function () {
    this.inputs.length = 0;
  };

  // PROCESS INPUT:
  this.procInputs = function (input, game, recon) {
    // RECON:
    this.recon = recon;

    // NOCLIP: force onGround so gravity never applies while free-flying.
    if (this.noclip) {
      this.onGround = true;
    }

    // VALS:
    var delta = Math.min(input[1], config.dltMx) / this.deltaDiv;
    this.inputSN = input[0];

    // SPINNING:
    var spinDist = UTILS.getAngleDist(input[2], this.xDire);
    manager.saveSpin(this, spinDist);

    // ANIMATE:
    var animate = !recon && this.isYou;
    if (animate) {
      this.leanAnimX -= spinDist * config.leanSens;
      this.leanAnimX = UTILS.limit(this.leanAnimX, config.leanMax);
      this.leanAnimY -= UTILS.getAngleDist(input[3], this.yDire) * config.leanSens;
      this.leanAnimY = UTILS.limit(this.leanAnimY, config.leanMax);
      if (this.leanAnimX) {
        this.leanAnimX *= Math.pow(config.leanPull, delta);
      }
      if (this.leanAnimY) {
        this.leanAnimY *= Math.pow(config.leanPull, delta);
      }
      if (this.leanAnimZ) {
        this.leanAnimZ *= Math.pow(config.leanPullZ, delta);
      }
      if (this.bobAnimZ) {
        this.bobAnimZ *= Math.pow(config.bobPullZ, delta);
      }
      if (this.bobAnimY) {
        this.bobAnimY *= Math.pow(config.bobPullY, delta);
      }
      if (this.recoilX) {
        this.recoilX *= Math.pow(config.leanPull, delta);
      }
      if (this.recoilZ) {
        this.recoilZ *= Math.pow(config.leanPull, delta);
      }
      if (this.inspecting) {
        if (this.inspectX < Math.PI / 2.8) {
          this.inspectX += (Math.PI / 2.8 - this.inspectX) * 0.1;
        }
      }
    }

    // SWAP WEAPON:
    if (input[11] == 2) {
      manager.swapMelee(this, recon);
    } else {
      if (input[11] == 1) {
        manager.swapSecondary(this, recon);
      } else {
        if (input[11] == 3) {
          manager.swapWeapon(this, null, null, undefined, 0, recon);
        } else {
          if (input[10]) {
            manager.swapWeapon(this, input[10], false, undefined, undefined, recon);
          }
        }
      }
    }

    // RECOIL:
    if (!recon) {
      if (this.recoilForce) {
        this.recoilAnim += this.recoilForce * delta;
        this.recoilAnimY += this.recoilForce * (this.weapon.recoilY || 1) * (1 - 0.3 * this.crouchVal) * delta;
        this.recoilForce *= Math.pow(this.weapon.recoverF, delta);
      }
      if (this.recoilAnim) {
        this.recoilAnim *= Math.pow(this.weapon.recover, delta);
      }
      if (this.recoilAnimY) {
        this.recoilAnimY *= Math.pow(this.weapon.recoverY || this.weapon.recover, delta);
      }
    }

    // DIRECTION:
    this.xDire = (input[2] || 0).round(3);
    this.yDire = (input[3] || 0).round(3);
    if (this.yDire > Math.PI / 2) {
      this.yDire = Math.PI / 2;
    } else {
      if (this.yDire < -(Math.PI / 2)) {
        this.yDire = -(Math.PI / 2);
      }
    }

    // PREVIOUS POSITIONS:
    this.oldX = this.x;
    this.oldY = this.y;
    this.oldZ = this.z;

    // AIM ANIMATION:
    if (this.weapon.zoom && (!this.weapon.noAim || this.swapTime > 0)) {
      var canZoom = this.reloadTimer <= 0 && this.swapTime <= 0;
      if (input[6] && this.aimVal > 0 && canZoom) {
        manager.cancelInspect(this);
        this.aimDir = 0;
        this.aimVal -= 1 / (this.weapon.aimSpeed / delta);
        if (this.aimVal <= 0) {
          this.aimVal = 0;
          if (this.isYou && !recon) {
            manager.toggleAim(this, 1);
          }
        }
        if (this.isYou && !recon && !this.weapon.scope) {
          manager.updateAim(this, 1 - this.aimVal);
        }
      } else {
        if (!canZoom || !input[6] && this.aimVal < 1) {
          this.aimDir = 1;
          if (!this.aimVal && this.isYou && !recon) {
            manager.toggleAim(this, 0);
          }
          this.aimVal += 1 / (this.weapon.aimSpeed / delta);
          if (this.aimVal >= 1) {
            this.aimVal = 1;
          }
          if (this.isYou && !recon && !this.weapon.scope) {
            manager.updateAim(this, 1 - this.aimVal);
          }
        }
      }
      if (this.aimVal == 0) {
        this.aimTime += delta;
      } else {
        this.aimTime = 0;
      }
    }

    // CROUCHING:
    if (input[8] && this.crouchVal < 1 && !this.onLadder) {
      this.crouchVal += config.crouchSpeed * delta;
      if (this.crouchVal >= 1) {
        this.crouchVal = 1;
      }
      if (!this.onGround) {
        this.y += config.crouchSpeed * delta;
      } else {
        if (animate) {
          this.bobAnimY -= config.crouchAnim * 1.4 * delta;
        }
      }
    } else {
      if (!input[8] && this.crouchVal > 0) {
        this.crouchVal -= config.crouchSpeed * delta;
        if (this.crouchVal <= 0) {
          this.crouchVal = 0;
        }
        if (!this.onGround) {
          this.y -= config.crouchSpeed * delta;
        } else {
          if (animate) {
            this.bobAnimY += config.crouchAnim * delta;
          }
        }
      }
    }
    if (this.crouchVal) {
      this.crouchVal = this.crouchVal.round(3);
    }

    // SET HEIGHT:
    manager.updateHeight(this);

    // SPEEDS:
    var grounded = this.onGround || this.onLadder;
    var tmpSpeed;
    if (grounded) {
      tmpSpeed = (this.terrainSlipping ? config.slippingSpeed : config.playerSpeed) * this.speed;
    } else {
      tmpSpeed = config.airSpeed;
    }
    tmpSpeed *= this.aimVal ? 1 : config.aimSlow;
    tmpSpeed *= game.mode.spdMlt ? game.mode.spdMlt[this.team] || 1 : 1;
    tmpSpeed *= this.crouchVal ? config.crouchSlow : 1;
    tmpSpeed *= this.weapon.spdMlt * delta;
    var tmpDecel = 0;
    if (this.onLadder) {
      tmpDecel = config.ladderDecel;
    } else {
      if (this.terrainSlipping) {
        tmpDecel = config.terrainSlipDecel;
      } else {
        if (this.onTerrain) {
          tmpDecel = config.terrainDecel;
        } else {
          if (this.onGround) {
            tmpDecel = config.groundDecel;
          } else {
            tmpDecel = config.airDecel;
          }
        }
      }
    }

    // SLIDE:
    if (this.crouchVal <= 0.5) {
      this.canSlide = true;
    }
    if (!this.onGround || !this.crouchVal) {
      this.slideTimer = 0;
    }
    if (this.slideTimer) {
      this.slideTimer -= delta;
      if (this.slideTimer <= 0) {
        this.slideTimer = 0;
      } else {
        tmpSpeed *= 0.25;
        tmpDecel = this.onTerrain ? config.terrainSlideDecel : config.slideDecel;
        var totalSpeed = UTILS.getDistance(this.xVel, this.zVel, 0, 0);
        var curDir = UTILS.getDirection(0, 0, this.xVel, this.zVel);
        var tDir = UTILS.getDirection(Math.sin(this.xDire), Math.cos(this.xDire), 0, 0);
        var tDst = UTILS.getAngleDist(tDir, curDir) * 0.03;
        this.xVel = totalSpeed * Math.cos(curDir + Math.PI - tDst);
        this.zVel = totalSpeed * Math.sin(curDir + Math.PI - tDst);
      }
    }

    // GAME LOCK MOVEMENT:
    if (game.lockMove) {
      tmpSpeed *= 0;
    }

    // JUMP:
    this.jumpCooldown = Math.max(this.jumpCooldown - delta, 0);
    if (this.onGround && this.jumpCooldown <= 0) {
      manager.tryJump(this, input[7]);
    }

    // GRAVITY:
    // NOCLIP: onGround is forced true (see COLLISIONS below), so grounded
    // is true and gravity never applies while free-flying.
    if (!grounded) {
      this.yVel -= delta * (config.gravity * (game.config ? game.config.gravMlt : 1));
    }

    // MOVE:
    var inputDir = config.movDirs[input[4]];
    if (inputDir != Math.PI && inputDir != 0 && inputDir != Math.PI / 2 && inputDir != -Math.PI / 2) {
      tmpSpeed *= game.config ? game.config.strafeSpd : 1;
    }
    if (inputDir !== undefined) {
      this.xVel += tmpSpeed * Math.cos(inputDir - this.xDire);
      this.zVel += tmpSpeed * Math.sin(inputDir - this.xDire);
      // NOCLIP: fly toward where you're looking — vertical velocity from
      // look-pitch while moving (yDire is the v1.5.2 pitch var).
      if (this.noclip) {
        this.yVel += tmpSpeed * (this.yDire * (inputDir > 0 ? -1 : 1));
      }
    }

    // APPLY VELOCITY:
    if (this.xVel) {
      this.x += this.xVel * delta;
      this.xVel *= Math.pow(tmpDecel, delta);
      this.xVel = UTILS.cropVal(this.xVel, config.decelMin);
    }
    if (this.yVel) {
      this.y += this.yVel * delta;
      // NOCLIP: normal velocity decay instead of gravity carry.
      this.yVel *= Math.pow(tmpDecel, delta);
    }
    if (this.zVel) {
      this.z += this.zVel * delta;
      this.zVel *= Math.pow(tmpDecel, delta);
      this.zVel = UTILS.cropVal(this.zVel, config.decelMin);
    }

    // COLLISIONS:
    // NOCLIP: skip the entire collision/ramp/terrain resolution so the
    // player free-flies through world geometry.
    var wasOnGround = this.onGround && !this.didJump;
    var onRamp = false;
    // NOCLIP: keep onGround true so gravity/landing logic stays disabled.
    this.onGround = this.noclip || false;
    this.onLadder = false;
    var interact = false;
    for (var i = 0; !this.noclip && i < game.map.manager.objects.length; ++i) {
      tmpObj = game.map.manager.objects[i];
      if (tmpObj.active && this.collides(tmpObj)) {
        // SCORE OBJECT:
        if (tmpObj.score) {
          if (!this.scoreObjs[tmpObj.sid]) {
            this.scoreObjs[tmpObj.sid] = 1;
            manager.score(this, tmpObj.scoreP);
          }
        }

        // TELEPORTER:
        else {
          if (tmpObj.teleporter) {
            game.checkTeleport(this, tmpObj);

            // CHECK POINT:
          } else {
            if (tmpObj.checkpoint) {
              game.setCheckPoint(this, tmpObj);

              // WEAPON PICKUP:
            } else {
              if (UTILS.isNumber(tmpObj.pickup)) {
                interact = true;

                // FLAG:
              } else {
                if (tmpObj.flag) {
                  game.pickupFlag(this, tmpObj);

                  // TRIGGER ZONE:
                } else {
                  if (tmpObj.trigger) {
                    // CAPTURE FLAG:
                    if (this.flag && tmpObj.team == this.team && tmpObj.flagObj && !tmpObj.flagObj.carrier && tmpObj.flagObj.x == tmpObj.flagObj.orgX && tmpObj.flagObj.y == tmpObj.flagObj.orgY && tmpObj.flagObj.z == tmpObj.flagObj.orgZ) {
                      game.capFlag(this, this.flag);
                    }
                  }

                  // KILL OBJECT:
                  else {
                    if (tmpObj.kill) {
                      if (this.flag) {
                        game.resetFlag(this.flag);
                        this.flag = null;
                      }
                      if (manager.hasServer) {
                        manager.kill(this);
                      }

                      // LADDER:
                    } else {
                      if (tmpObj.ladder) {
                        if (this.y < tmpObj.y + tmpObj.height && this.crouchVal == 0) {
                          this.yVel = 0;
                          this.onLadder = true;
                          this.onTerrain = false;
                          this.stepSrc = null;
                          if (inputDir !== undefined) {
                            var tmpDr = (Math.abs(UTILS.getAngleDist(tmpObj.dir, inputDir - this.xDire)) - Math.PI / 2) / (Math.PI / 2);
                            if (tmpDr > 0) {
                              this.y += config.ladderSpeed * this.weapon.spdMlt * delta * tmpDr;
                              if (this.y <= tmpObj.y - tmpObj.height) {
                                this.y = tmpObj.y - tmpObj.height;
                              } else {
                                if (this.y >= tmpObj.y + tmpObj.height) {
                                  this.y = tmpObj.y + tmpObj.height;
                                }
                              }
                            }
                          }
                        }
                      }

                      // RAMP:
                      else {
                        if (tmpObj.ramp) {
                          if (this.y < tmpObj.y + tmpObj.height) {
                            var tmpProg = Math.max(0, Math.min(1, UTILS.progressOnLine(tmpObj.ramp.sX, tmpObj.ramp.sZ, tmpObj.ramp.eX, tmpObj.ramp.eZ, this.x + this.scale * Math.cos(tmpObj.dir), this.z + this.scale * Math.sin(tmpObj.dir))));
                            var tmpY = tmpObj.y - tmpObj.height + tmpObj.height * 2 * tmpProg;
                            if (this.y <= tmpY || wasOnGround) {
                              if (tmpObj.boost) {
                                this.y = tmpY;
                                var tmpSpd = tmpObj.boost * config.boosterSpd * delta;
                                this.xVel += tmpSpd * Math.sin(-tmpObj.dir + Math.PI / 2) * Math.cos(tmpObj.boostDr);
                                this.zVel += tmpSpd * Math.cos(-tmpObj.dir + Math.PI / 2) * Math.cos(tmpObj.boostDr);
                                this.yVel += tmpSpd * Math.sin(tmpObj.boostDr);
                              } else {
                                if (this.oldY > this.y) {
                                  manager.resetStep(this, recon);
                                }
                                this.y = tmpY;
                                this.yVel = 0;
                                this.onGround = true;
                                this.onTerrain = false;
                                onRamp = true;
                                this.rampFix = tmpObj.y - tmpObj.height + tmpObj.height * 2 * Math.round(tmpProg);
                              }
                            }
                          }
                        }

                        // AUTO CLIMB:
                        else {
                          if (!tmpObj.isBorder && this.y < tmpObj.y + tmpObj.height && tmpObj.y + tmpObj.height - this.y <= config.climbHeight && this.oldY < tmpObj.y + tmpObj.height && wasOnGround) {
                            this.y += (tmpObj.y + tmpObj.height - this.y) * 0.3;
                            this.onGround = true;
                            this.onTerrain = false;
                          }

                          // RECTANGLE:
                          else {
                            if (this.oldY >= tmpObj.y + tmpObj.height + (tmpObj.isBorder ? config.borderH : 0)) {
                              this.stepSrc = tmpObj.stepSrc;
                              if (this.oldY > this.y) {
                                manager.resetStep(this, recon);
                              }
                              this.y = tmpObj.y + tmpObj.height + (tmpObj.isBorder ? config.borderH : 0);
                              this.yVel = 0;
                              this.onGround = true;
                              this.onTerrain = false;
                            } else {
                              if (this.oldX - this.scale >= tmpObj.x + tmpObj.width - 0.00001) {
                                this.x = tmpObj.x + tmpObj.width + this.scale;
                                this.xVel = 0;
                              } else {
                                if (this.oldX + this.scale <= tmpObj.x - tmpObj.width + 0.00001) {
                                  this.x = tmpObj.x - tmpObj.width - this.scale;
                                  this.xVel = 0;
                                } else {
                                  if (this.oldZ - this.scale >= tmpObj.z + tmpObj.length - 0.00001) {
                                    this.z = tmpObj.z + tmpObj.length + this.scale;
                                    this.zVel = 0;
                                  } else {
                                    if (this.oldZ + this.scale <= tmpObj.z - tmpObj.length + 0.00001) {
                                      this.z = tmpObj.z - tmpObj.length - this.scale;
                                      this.zVel = 0;
                                    } else {
                                      if (this.oldY + this.height <= tmpObj.y - tmpObj.height) {
                                        this.y = tmpObj.y - tmpObj.height - this.height;
                                        this.yVel = 0;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // FIX RAMP:
    if (!this.noclip && !this.didJump && this.rampFix != null && Math.abs(this.y - this.rampFix) <= config.climbHeight) {
      if (!onRamp) {
        this.y = this.rampFix;
        this.onGround = true;
        this.yVel = 0;
        this.rampFix = null;
      }
    } else {
      this.rampFix = null;
    }

    // TERRAIN:
    // NOCLIP: skip terrain clamp so the player free-flies below ground.
    var terrain = this.noclip ? null : game.map.terrain;
    if (terrain) {
      var intersectPoint = terrain.raycast(this.x, -this.z, 10000, 0, 0, -20000, true);
      if (intersectPoint) {
        // GET TERRAIN HEIGHT:
        var terrainHeight = intersectPoint.z;

        // RESET STEP:
        if (this.y <= terrainHeight) {
          if (this.oldY > this.y) {
            manager.resetStep(this, recon);
          }

          // UPDATE STATE:
          this.onTerrain = true;
        }
        if (this.onTerrain) {
          // UPDATE STATE:
          this.onGround = true;

          // GET TERRAIN NORMAL AND CONVERT COORDINATE SPACES:
          var tN = terrain._raycastNormal;
          tN.set(tN.x, tN.z, -tN.y);

          // UPDATE POSITION:
          if (false) {
            var dH;
            var nH;
            var nY;
            var dY;
          } else {
            // UPDATE Y POS:
            this.y = terrainHeight;
          }

          // GET SLIDING NORMAL:
          var sX = tN.x;
          var sY = -1 + tN.y;
          var sZ = tN.z;

          // TERRAIN SLIPPING:
          var sLen = Math.sqrt(sX * sX + sY * sY + sZ * sZ); // ADJUST MIN SLIDE
          this.terrainSlipping = sLen > config.terrainSlideThreshold;
          this.terrainSlipping = false; // TEMP: DISABLE SLIPPING
          if (this.terrainSlipping) {
            // UPDATE SLIDE LEN:
            var gravity = config.gravity * (game.config ? game.config.gravMlt : 1) * config.terrainGravityMlt;
            sLen *= gravity * delta;

            // UPDATE VELOCITY
            this.xVel += sX * sLen;
            this.yVel += sY * sLen;
            this.zVel += sZ * sLen;
          } else {
            // REMOVE VERTICAL VELOCITY:
            this.yVel = 0;

            // REMOVE JUMP COOLDOWN:
            this.jumpCooldown = 0;
          }
        }
      }

      // REMOVE SLIDING IF NEEDED:
      if (!this.onTerrain) {
        this.terrainSlipping = false;
      }
    }

    // AIR TIME:
    if (!this.onGround) {
      this.airTime += delta;
    } else {
      this.airTime = 0;
    }

    // NOT RECONCILING:
    if (!recon) {
      // MOVEMENT ANIMATION CLIENT:
      var moveVal = UTILS.getDistance3D(this.oldX, this.oldY, this.oldZ, this.x, this.y, this.z);
      if (this.isYou) {
        if (this.onLadder) {
          moveVal *= 1.4;
        }
        var moveDir = UTILS.getDirection(this.oldX, this.oldZ, this.x, this.z);
        this.bobAnimZ += UTILS.getDistance(this.oldX, this.oldZ, this.x, this.z) * config.bobMltZ;
        this.bobAnimY -= (this.oldY - this.y) * config.bobMltY;
        if (grounded && inputDir !== undefined) {
          manager.playerStep(this, moveVal);
          this.leanAnimZ -= moveVal * config.leanMltZ * (this.weapon.zLnM || 1) * Math.cos(inputDir);
        } else {
          this.stepVal *= Math.pow(config.stepPull, delta);
        }
        if (this.stepChase != this.stepVal) {
          this.stepChase += (this.stepVal - this.stepChase) * 0.15;
        }
      }

      // SET SPREAD:
      this.spreadPlus += moveVal * config.spreadMove + Math.abs(this.oldY - this.y) * config.spreadFall;
      this.spreadPlus *= Math.pow(config.spreadRecover, delta);
      this.spread = Math.max(this.weapon.minSpread || 0, (this.weapon.spread - this.weapon.spread * config.crouchSpread * this.crouchVal + this.recoilAnim * (this.weapon.spreadInc || 1) * config.spreadMlt + this.spreadPlus) * this.aimVal);

      // RELOAD:
      if (input[9]) {
        manager.reload(this);
      }
      if (this.reloadTimer > 0) {
        var lastTimer = this.reloadTimer;
        this.reloadTimer -= delta;
        if (this.isYou && lastTimer >= this.weapon.reload / 2 && this.reloadTimer < this.weapon.reload / 2) {
          manager.endReload(this.weapon);
        }
        if (this.reloadTimer <= 0) {
          this.reloadTimer = 0;
          this.didShoot = false;
          this.ammos[this.weaponIndex] = this.weapon.ammo;
          manager.updatePlayerAmmo(this);
        }
      }

      // SHOOTING:
      if (this.swapTime > 0) {
        this.swapTime -= delta;
        if (this.swapTime < 0) {
          this.swapTime = 0;
        }
      }
      for (var i = 0; i < this.reloads.length; ++i) {
        if (this.reloads[i] > 0) {
          this.reloads[i] -= delta;
          if (this.reloads[i] < 0) {
            this.reloads[i] = 0;
          }
        }
      }
      if (this.weapon) {
        var shooting = this.weapon.nAuto ? false : input[5];
        if (this.didShoot && !input[5]) {
          this.didShoot = false;
        }
        if (!this.didShoot && input[5]) {
          shooting = true;
        }
        if (shooting && this.reloads[this.weaponIndex] <= 0 && this.swapTime <= 0 && this.reloadTimer <= 0) {
          this.noMovTimer = 0;
          if (this.weapon.melee) {
            manager.melee(this);
          } else {
            if (this.ammos[this.weaponIndex] > 0) {
              manager.shoot(this, input);
            } else {
              manager.reload(this);
            }
          }
        }
      }
    }

    // SHOOT VELOCITY RECON:
    if (recon && input.velObj) {
      this.xVel -= input.velObj.x;
      this.zVel -= input.velObj.y;
      // NOCLIP: skip the vertical knockback so free-fly isn't perturbed.
      if (!this.noclip) {
        this.yVel -= input.velObj.z;
      }
      this.onGround = false;
    }

    // PLAYER COLLISIONS:
    manager.playerCollisions(this);
    manager.updateInteract(this, interact);
  };

  // COLLIDES:
  this.collides = function (other) {
    return this.x - this.scale < other.x + other.width && this.x + this.scale > other.x - other.width && this.z - this.scale < other.z + other.length && this.z + this.scale > other.z - other.length && this.y <= other.y + other.height + (other.isBorder ? config.borderH : 0) && this.y + this.height >= other.y - other.height;
  };

  // UPDATE:
  this.update = function (game, delta) {
    if (this.active) {
      // PROCESS INPUTS:
      if (this.inputs.length) {
        for (var i = 0; i < this.inputs.length; ++i) {
          this.procInputs(this.inputs[i], game);
        }
        this.resetInputs();
      }

      // IDLE SWAY:
      this.idleAnim += config.idleAnimS * delta;

      // HEALTH CHASE:
      if (this.hpChase > this.health) {
        this.hpChase -= 0.035 * delta;
        if (this.hpChase <= this.health) {
          this.hpChase = this.health;
        }
      } else {
        this.hpChase = this.health;
      }

      // INTERPOLATE:
      if (this.interpolate) {
        this.dt += delta;
        var rate = Math.min(1.6, this.dt / (config.serverSendRate * config.interpolation));
        rate /= game.config ? game.config.deltaMlt : 1;
        this.oldX = this.x;
        this.oldY = this.y;
        this.oldZ = this.z;
        this.x = this.x1 + (this.x2 - this.x1) * rate;
        this.y = this.y1 + (this.y2 - this.y1) * rate;
        this.z = this.z1 + (this.z2 - this.z1) * rate;
        if (this.onGround) {
          manager.playerStep(this, UTILS.getDistance(this.oldX, this.oldZ, this.x, this.z));
        }
        this.xDire = Math.lerpAngle(this.xDir2, this.xDir1, Math.min(1, rate));
        this.yDire = Math.lerpAngle(this.yDir2, this.yDir1, Math.min(1, rate));
      }
    }
  };

  // RESET PLAYER ANIM:
  this.resetMeleeAnim = function () {
    this.meleeAnim.armT = 0;
    this.meleeAnim.armM = 0;
    this.meleeAnim.armE = 0;
    this.meleeAnim.weaR = 0;
    this.meleeAnim.weaM = 0;
    this.meleeAnim.armY = 0;
    this.meleeAnim.armR = 0;
    this.meleeAnim.lArm = 0;
    this.meleeAnim.flipW = 0;
  };

  // RESET PLAYER:
  this.reset = function () {
    this.checkPoint = null;
    this.checkPointList.length = 0;
    this.killList.length = 0;
    this.customLoadout = null;
    this.lastPicked.length = 0;
  };
}
module.exports.Player = Player;

// PLAYER MANAGER:
module.exports.manager = function (game, RENDER, SOUND, PARTICLES, UTILS, config, io) {
  // INIT:
  this.list = [];
  var tmpObj;
  var tmpObj2;
  var tmpData;
  var KILLS = require(/*! ./kills.js */"./kills.js");
  this.hasServer = io ? 1 : 0;

  // SET TEAM:
  this.setTeam = function (player) {
    if (!game.waitTimers && game.mode.convTeam) {
      player.team = game.mode.convTeam;
    } else {
      if (game.mode.startTeam) {
        player.team = game.mode.startTeam;
      } else {
        if (game.mode.friendly) {
          player.team = 1;
        } else {
          if (game.mode.clanWar) {
            player.team = player.account && player.account.clan ? player.account.clan : 1;
          } else {
            if (!player.team && game.mode.teams && !player.spectating) {
              var t1c = 0;
              var t2c = 0;
              for (var i = 0; i < this.list.length; ++i) {
                if (!this.list[i].spectating) {
                  if (this.list[i].team == 1) {
                    t1c++;
                  }
                  if (this.list[i].team == 2) {
                    t2c++;
                  }
                }
              }
              player.team = t1c >= t2c ? 2 : 1;
            }
          }
        }
      }
    }
  };

  // UPDATE:
  this.update = function (delta) {
    // UPDATE PLAYERS:
    for (var i = 0; i < this.list.length; ++i) {
      tmpObj = this.list[i];
      if (tmpObj.active) {
        tmpObj.update(game, delta);
        if (io) {
          this.tickPlayer(tmpObj, delta);
          this.storeState(tmpObj);
          if (!tmpObj.noclip && tmpObj.y <= game.map.deathY) {
            if (tmpObj.flag) {
              game.resetFlag(tmpObj.flag);
              tmpObj.flag = null;
            }
            this.kill(tmpObj);
          }
        }
        if (RENDER) {
          this.updateMesh(tmpObj);
          this.updateHeight(tmpObj);
        }
      }
    }
  };

  // PLAYER COLLISIONS:
  this.playerCollisions = function (player) {
    if (io && game.mode.convTeam && !game.waitTimers) {
      for (var i = 0; i < this.list.length; ++i) {
        if (player.active && this.list[i].active && player.team == game.mode.convTeam && player.team != this.list[i].team) {
          var tmH = config.playerHeight / 2;
          var tmpDst = UTILS.getDistance3D(player.x, player.y + tmH, player.z, this.list[i].x, this.list[i].y + tmH, this.list[i].z);
          if (tmpDst <= tmH * 2.4) {
            io.broadcast("game" + game.sid, "ac", player.sid, this.list[i].sid, game.mode.convWord);
            this.score(player, 100);
            player.convs++;
            game.updateTeam(this.list[i], player.team);
            if (game.mode.killConv) {
              this.kill(this.list[i], null, null, true);
            }
            if (game.gameTimer) {
              game.gameTimer += 10000;
            }
          }
        }
      }
    }
  };

  // GET ACTIVE COUNT:
  this.activeCount = function () {
    var tmpC = 0;
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].active) {
        tmpC++;
      }
    }
    return tmpC;
  };

  // FORCE POSITION:
  this.forcePos = function () {
    for (var i = 0; i < this.list.length; ++i) {
      this.list[i].forcePos = true;
      if (this.list[i].objInstances) {
        this.list[i].objInstances.visible = false;
        this.list[i].inView = false;
      }
    }
  };

  // SPINS:
  this.saveSpin = function (player, spins) {
    if (io) {
      player.spins.unshift(spins);
      if (player.spins.length > config.spinTimer / config.serverTickRate) {
        player.spins.length = Math.round(config.spinTimer / config.serverTickRate);
      }
    }
  };
  this.getSpin = function (player) {
    var tmpSpin = 0;
    for (var i = 0; i < player.spins.length; ++i) {
      tmpSpin += player.spins[i];
    }
    return Math.abs(tmpSpin * (180 / Math.PI));
  };

  // STORE STATE:
  this.storeState = function (player) {
    player.stateHistory.unshift({
      time: game.now,
      x: player.x,
      y: player.y,
      z: player.z
    });
    for (var i = player.stateHistory.length - 1; i >= 0; --i) {
      if (game.now - player.stateHistory[i].time >= config.stateHistory) {
        player.stateHistory.splice(i, 1);
      }
    }
    ;
  };

  // FETCH STATE:
  this.fetchState = function (player, ping) {
    var backTime = game.now - (ping + config.serverSendRate * config.interpolation);
    for (var i = 0; i < player.stateHistory.length; ++i) {
      if (player.stateHistory[i].time <= backTime) {
        return player.stateHistory[i];
      }
    }
    ;
    return player.stateHistory[player.stateHistory.length - 1];
  };

  // UPDATE PLAYER MESH:
  this.updateMesh = function (player, prv) {
    if (!player.objInstances) {
      return;
    }

    // VALUES:
    var aimVM = player.weapon.animWhileAim ? 1 : player.aimVal;
    var animMlt = (1 - (1 - config.aimAnimMlt) * (1 - player.aimVal)) * config.animMult * RENDER.weaponLean;
    var animMltC = 1 - 0.8 * player.crouchVal;
    var animMltL = (1 - (1 - player.aimVal)) * config.animMult;
    if (!player.isYou) {
      animMltL = 0;
    }
    var recoilZMlt = 1 - (player.weapon.recoilZM || 0.5) * (1 - aimVM);
    var animRMlt = (1 - (player.weapon.zRot || 0.3) * (1 - aimVM)) * (player.weapon.zRM || 1) * RENDER.weaponLean;
    var animYMlt = 1 - (player.weapon.jYMlt || 1) * (1 - aimVM);
    var leanAimMlt = 1 - 0.45 * (1 - aimVM);
    var bobAnimY = player.bobAnimY * 0.9 * animYMlt * RENDER.weaponLean * animMltL;
    var landBobY = player.landBobY * (player.weapon.landBob || 1) * 0.6 * (1 - 0.75 * (1 - aimVM)) * RENDER.weaponLean;
    if (player.landBobYR != landBobY) {
      player.landBobYR += (landBobY - player.landBobYR) * 0.1;
    }
    var landBobYA = player.landBobY * (player.weapon.landBob || 1) * 0.1;
    var bobCMlt = 1 - 0.5 * player.crouchVal;
    var cIMlt = 1 - 1 * player.crouchVal;
    var jumpRot = player.jumpRot * bobCMlt * animMltL * RENDER.weaponLean;
    if (player.jumpRotM != jumpRot) {
      player.jumpRotM += (jumpRot - player.jumpRotM) * 0.08;
    }
    var jumpBobY = player.jumpBobY * (player.weapon.jumpYM || 1) * animMltL * bobCMlt * RENDER.weaponLean;
    var recAMlt = 1 - 0.89 * (1 - aimVM);
    var recMlt = 1 - (player.weapon.aimRecMlt || 1) * (1 - aimVM);
    var stepMlt = prv ? 0.05 : config.stepAnim;
    var stepAnim = Math.sin(player.stepVal) * stepMlt;
    var stepHalf = Math.cos(2 * player.stepVal) / 2 * stepMlt;
    var stepAnimR = -Math.sin(player.stepChase) * stepMlt;
    var stepHalfR = -(Math.cos(2 * player.stepChase) / 2) * stepMlt;
    var aimVal = game.config.thirdPerson ? 0 : 1 - player.aimVal;
    var aimLean = (aimVal <= 0.5 ? aimVal : 0.5 - (aimVal - 0.5)) * 0.5;
    var swapAnim = player.swapTime / player.weapon.swapTime;
    var wXoff = player.weapon.xOff;
    var reloadAnim = 0;
    if (player.reloadTimer > 0) {
      reloadAnim = 1 - player.reloadTimer / player.weapon.reload;
      reloadAnim = reloadAnim > 0.5 ? 0.5 - (reloadAnim - 0.5) : reloadAnim;
    }
    var idleAim = (1 - 0.88 * (1 - player.aimVal)) * 1.5 * RENDER.weaponLean;

    // POSITION MESH:
    RENDER.moveMesh(player.objInstances, player.x, player.y + (player.isYou && !game.config.thirdPerson ? 0 : Math.abs(stepAnim * 3.5)), player.z);
    RENDER.rotateMesh(player.objInstances, player.xDire + (player.isYou ? game.config.thirdPerson ? -stepAnim * 0.5 : 0 : -stepAnim * 2));

    // FIX VALS:
    stepHalf -= stepHalf * (player.crouchVal * config.crouchAnimMlt);
    stepAnim -= stepAnim * (player.crouchVal * config.crouchAnimMlt);

    // LEGS:
    for (var i = 0; i < player.legMeshes.length; ++i) {
      player.legMeshes[i].rotation.x = stepAnim * (i == 1 || i == 3 ? 1 : -1) * 7 + (i > 1 ? -0.6 : 0);
    }

    // ARMS:
    for (var i = 0; i < player.armMeshes.length; ++i) {
      var tmpArmM = -(player[(i == 0 ? "l" : "r") + "HndTweenA"] || 0);
      player.armMeshes[i].position.z = stepAnim * (!i ? 1 : -1);
      player.armMeshes[i].rotation.x = player.armMeshes[i].xR || 0;
      player.armMeshes[i].rotation.y = player.armMeshes[i].yR || 0;
      player.armMeshes[i].position.x = player.armMeshes[i].xP || 0;
      player.armMeshes[i].position.y = player.armMeshes[i].yP || 0;
      if (i == 1) {
        player.armMeshes[1].rotation.z = player.armMeshes[i].zR + player.crouchVal * 0.12 + -1.0 * stepHalfR + player.jumpBobY * 0.2;
        if (player.meleeAnim && player.weaponGeos[player.weaponIndex]) {
          player.armMeshes[1].rotation.z += (player.meleeAnim.armR || 0) * animMltL;
          player.armMeshes[1].rotation.y += (player.meleeAnim.armT || 0) * animMltL;
          player.armMeshes[1].position.x += (player.meleeAnim.armM || 0) * animMltL;
          player.armMeshes[1].position.z += (player.meleeAnim.armE || 0) * animMltL;
          player.armMeshes[1].position.y += (player.meleeAnim.armY || 0) * animMltL;
          if (player.weaponGeos[player.weaponIndex]) {
            player.weaponGeos[player.weaponIndex].rotation.z = player.weaponGeos[player.weaponIndex].zR + (player.meleeAnim.weaR || 0);
            player.weaponGeos[player.weaponIndex].position.x = player.weaponGeos[player.weaponIndex].xP + (player.meleeAnim.weaM || 0);
            player.weaponGeos[player.weaponIndex].rotation.y = player.weaponGeos[player.weaponIndex].yR + (player.meleeAnim.flipW || 0);
          }
        }
      } else {
        if (player.meleeAnim && player.weaponGeos[player.weaponIndex]) {
          player.armMeshes[0].position.z += player.meleeAnim.lArm || 0;
          player.armMeshes[0].rotation.y += (player.meleeAnim.lArm || 0) * 0.1;
          player.armMeshes[0].position.x -= (player.meleeAnim.lArm || 0) * 0.3;
        }
      }
    }

    // ATTACHMENT:
    var tmpAttach = game.attach[player.weapon.attach];
    var aimYOff = tmpAttach ? tmpAttach.aimOffY || 0 : 0;

    // FLAP:
    if (player.weaponMeshes[player.weaponIndex].flapMesh && player.weapon.flap) {
      fRot = stepHalfR * 3 + player.recoilAnim * 2.8 - player.leanAnimZ - player.leanAnimX * 3 - player.landBobYR * 1.8 + bobAnimY + player.crouchVal * 0.1;
      RENDER.rotateMesh(player.weaponMeshes[player.weaponIndex].flapMesh, player.weapon.flap.rot * player.swapTweenA + fRot, null, null);
    }

    // ANIMATE YOU:
    var thrdRed = game.config.thirdPerson ? 0.4 : 1;
    RENDER.rotateMesh(player.upperBody, reloadAnim * -(1.0 * thrdRed), -(bobAnimY * 0.2) + +landBobYA + reloadAnim * -(2.8 * thrdRed) + player.yDire * (player.isYou && !game.config.thirdPerson ? 1 : 0.5) + (-(Math.PI / 4) * swapAnim + player.recoilAnimY * config.recoilMlt) + (player.weapon.yRot || 0));
    RENDER.moveMesh(player.upperBody, 0, player.recoilAnimY * (player.weapon.recoilYM || 0.3) * animMltL + (player.height - config.cameraHeight - config.legHeight), 0);
    RENDER.rotateMesh(player.weaponMeshes[player.weaponIndex], player.inspectX + player.jumpRotM * 0.2 + player.recoilX * recAMlt + player.leanAnimX * leanAimMlt * RENDER.weaponLean * (player.weapon.leanMlt || 1) + (-stepAnimR * 0.16 * animMltL * animMltC + player.leanAnimZ * 0.2) * animMlt, -Math.cos(player.idleAnim) * bobCMlt * 0.01 * idleAim - (player.swapTweenR || 0) * 0.25 * animMltL + -player.landBobYR * 0.6 + player.recoilTweenY * recMlt + player.leanAnimY * leanAimMlt * RENDER.weaponLean * (player.weapon.leanMlt || 1) + -(stepHalfR * 0.9) * animMlt, jumpRot + aimLean + player.recoilX * recAMlt + (player.swapTweenR || 0) * animMltL * 0.1 + player.leanAnimZ * animRMlt + -player.inspectX * (player.weapon.inspectR || 0) + ((player.weapon.cLean || 0) * player.crouchVal * animMltL + -stepAnimR * 0.0) * animMlt);
    RENDER.moveMesh(player.weaponMeshes[player.weaponIndex], -(player.jumpRotM * animMltL * 1.3) + -player.inspectX * (player.weapon.inspectM || 0) + (player.leanAnimZ * 0.35 - (player.weapon.cRot || 0) * player.crouchVal * animMltL + stepAnim * 0.5 * animMltC * animMltL) * player.aimVal * animMlt + wXoff - (wXoff - player.weapon.xOrg) * aimVal, Math.sin(player.idleAnim) * 0.02 * idleAim + player.recoilTweenYM * recMlt + jumpBobY + landBobY * 0.7 - bobAnimY * 1.5 + (stepHalf * 0.85 - (player.weapon.cDrop || 0) * player.crouchVal * animMltL) * animMlt + player.weapon.yOff - (player.weapon.yOff - player.weapon.yOrg + aimYOff) * aimVal, player.weapon.zOff - (player.weapon.zOff - player.weapon.zOrg) * aimVal + player.bobAnimZ * animMlt + player.recoilAnim * (player.weapon.recoilZ || 0) * recoilZMlt);
  };

  // UPDATE HEIGHT:
  this.updateHeight = function (player) {
    var cVal = config.crouchDst * player.crouchVal;
    if (RENDER && (!player.isYou || game.config.thirdPerson)) {
      var crouchLean = config.crouchLean * player.crouchVal;
      RENDER.rotateMesh(player.lowerBody, 0, crouchLean + player.yDire * 0.5, 0);
      player.upperBody.rotation.x -= crouchLean;
      RENDER.moveMesh(player.lowerBody, 0, config.legHeight - cVal, 0);
      for (var i = 0; i < 4; ++i) {
        if (player.legMeshes[i]) {
          if (i <= 1) {
            player.legMeshes[i].visible = !player.crouchVal;
          } else {
            player.legMeshes[i].visible = player.crouchVal ? true : false;
          }
        }
      }
    } else {
      player.height = config.playerHeight - cVal;
    }
  };

  // GENERATE PLAYER MESH:
  this.generateMeshes = function (player, isYou, viewer = false) {
    // COLORS:
    var colors = game.classes[player.classIndex].colors;

    // GEN BODY:
    var genBod = game.config.thirdPerson || !isYou;

    // BODY:
    player.objInstances = RENDER.genObj3D(player.x, player.y, player.z);
    player.lowerBody = RENDER.genObj3D(0, config.legHeight, 0);
    if (genBod) {
      player.lowerBody.add(RENDER.genBody(colors[1], colors[2], colors[4], colors[0], player.isPreview || player.isYou));
    }

    // UPPER BODY:
    player.upperBody = RENDER.genObj3D(0, 0, 0);
    player.lowerBody.add(player.upperBody);

    // ADD BACK ITEM:
    if (player.backIndex >= 0 && genBod) {
      player.backMesh = RENDER.genObj3D(0, (config.playerHeight - config.legHeight - config.headScale) / 2 - (game.store.skins[player.backIndex].sitOff || 0), -(game.store.skins[player.backIndex].sitOffZ || 0));
      player.lowerBody.add(player.backMesh);
      RENDER.loadMesh({
        src: "body/body_" + game.store.skins[player.backIndex].id,
        texSrc: game.store.skins[player.backIndex].tex ? "body/body_" + game.store.skins[player.backIndex].id + "_" + game.store.skins[player.backIndex].tex : null,
        glowText: game.store.skins[player.backIndex].glow,
        emissive: game.store.skins[player.backIndex].glow ? 0xffffff : null,
        noGreen: true
      }, 0, 0, 0, Math.PI / 2, 2.1 * (game.store.skins[player.backIndex].sclMlt || 1), player.backMesh);
    }

    // ADD HAT:
    if (player.hatIndex >= 0 && genBod) {
      player.hatMesh = RENDER.genObj3D(0, config.playerHeight - config.legHeight - (game.store.skins[player.hatIndex].sitOff || 0), -(game.store.skins[player.hatIndex].sitOffZ || 0));
      player.lowerBody.add(player.hatMesh);
      RENDER.loadMesh({
        src: "hats/hat_" + game.store.skins[player.hatIndex].id,
        texSrc: game.store.skins[player.hatIndex].tex ? "hats/hat_" + game.store.skins[player.hatIndex].id + "_" + game.store.skins[player.hatIndex].tex : null,
        glowText: game.store.skins[player.hatIndex].glow,
        emissive: game.store.skins[player.hatIndex].glow ? 0xffffff : null,
        noGreen: true
      }, 0, 0, 0, Math.PI / 2, 2.1 * (game.store.skins[player.hatIndex].sclMlt || 1), player.hatMesh);
    }

    // LEGS:
    if (genBod) {
      for (var i = 0; i < 4; ++i) {
        player.legMeshes.push(RENDER.genLeg(i == 1 || i == 3, colors[2], colors[3], i > 1));
        if (i >= 2) {
          RENDER.rotateMesh(player.legMeshes[i], i == 2 ? -(Math.PI / 6) : Math.PI / 8, 0, 0);
        }
        player.legMeshes[i].visible = i <= 1;
        player.objInstances.add(player.legMeshes[i]);
      }
    }

    // WEAPONS & ARMS:
    for (var i = 0; i < player.ammos.length; ++i) {
      var tmpMesh = RENDER.genObj3D(0, 0, 0);
      var tmpWeap = game.weapons[player.loadout[i]];
      var tmpAttach = tmpWeap.attach != undefined ? game.attach[tmpWeap.attach] : null;
      if (isYou && tmpWeap.ammo) {
        tmpMesh.muzzles = [];
        tmpMesh.casings = [];
        for (var x = 0; x < 2; ++x) {
          if (!(x && !tmpWeap.akimbo)) {
            tmpMesh.muzzles.push(new THREE.Sprite());
            tmpMesh.muzzles[x].visible = false;
            tmpMesh.muzzles[x].static = true;
            PARTICLES.particles.push(tmpMesh.muzzles[x]);
            tmpMesh.add(tmpMesh.muzzles[x]);
            tmpMesh.casings.push(RENDER.genObj3D(x ? -tmpWeap.xOff * 2 : 0, tmpWeap.caseYOff || 0, tmpWeap.caseZOff || 0));
            tmpMesh.add(tmpMesh.casings[x]);
          }
        }
        tmpMesh.muzzleFlash = RENDER.genObj3D(0, 0.4, 0);
        tmpMesh.muzzles[0].add(tmpMesh.muzzleFlash);
      }
      if (tmpWeap.src) {
        // MERGED ARMS:
        tmpMesh.add(RENDER.genArms(tmpWeap, colors[1], colors[5], colors[0], null, player.isPreview || player.isYou));
      } else {
        // SEPARATE ARMS:
        for (var x = 0; x < 2; ++x) {
          var tmpA = RENDER.genArms(tmpWeap, colors[1], colors[5], colors[0], x + 1, player.isPreview || player.isYou);
          tmpMesh.add(tmpA);
          player.armMeshes.push(tmpA);
        }
      }
      player.weaponMeshes.push(tmpMesh);
      player.weaponMeshes[i].visible = false;
      player.upperBody.add(player.weaponMeshes[i]);

      // LOAD MELEE SKIN ON HANDS:
      if (player.armMeshes[1]) {
        var tmpMel = game.store.skins[player.meleeIndex] || {};
        player.weaponGeos[i] = RENDER.loadMesh({
          src: "melee/melee_" + (tmpMel.id || 0),
          texSrc: tmpMel.tex ? "melee/melee_" + (tmpMel.id || 0) + "_" + tmpMel.tex : "",
          glowText: tmpMel.glow,
          emissive: tmpMel.glow ? 0xffffff : null,
          tFilter: THREE.LinearFilter,
          mat: viewer || player.isYou ? THREE.MeshPhongMaterial : null,
          noGreen: true,
          uv2: true,
          specular: 0x292929,
          shininess: 100
        }, player.isYou ? 0.9 : 1.7, player.isYou ? -0.95 : -0.4, player.isYou ? 0.72 : 1.2, [-(Math.PI / 3.5), player.isYou ? 0.3 : Math.PI / 2, -(Math.PI * 0.9)], tmpMel.sclMlt || 0.9, player.armMeshes[1]);
        player.armMeshes[1].yR = player.armMeshes[1].rotation.y;
        if (player.isYou) {
          player.armMeshes[1].zR = player.armMeshes[1].rotation.z = -0.3;
          player.armMeshes[1].xR = player.armMeshes[1].rotation.x = -0.4;
          player.armMeshes[1].xP = player.armMeshes[1].position.x = 0.4;
          player.armMeshes[1].yP = player.armMeshes[1].position.y = 0.3;
        } else {
          player.armMeshes[1].zR = player.armMeshes[1].rotation.z = 0.3;
          player.armMeshes[1].yP = player.armMeshes[1].position.y = -0.4;
          player.armMeshes[1].xR = player.armMeshes[1].rotation.x;
          player.armMeshes[1].xP = player.armMeshes[1].position.x = -0.2;
        }
        player.armMeshes[0].xP = player.armMeshes[0].position.x = 0.3;
        player.armMeshes[0].yP = player.armMeshes[0].position.y = -0.5;
        player.armMeshes[0].zR = player.armMeshes[0].rotation.z = -0.4;
        player.armMeshes[0].yR = player.armMeshes[0].rotation.y;
      }

      // LOAD WEAPON MODEL:
      if (tmpWeap.src) {
        var tmpSkin = game.store.skins[player.skins[i]] || {};
        var emGlow = player.skins[i] >= 0 && (tmpSkin.glow || tmpSkin.sameGlow);
        for (var x = 0; x < 2; ++x) {
          if (!(x && !tmpWeap.akimbo)) {
            RENDER.loadMesh({
              src: "weapons/" + tmpWeap.src,
              texSrc: tmpSkin.tex ? tmpSkin.tex : player.skins[i] >= 0 ? "weapons/skins/" + tmpWeap.src + "_" + tmpSkin.id : null,
              tFilter: THREE.LinearFilter,
              mat: viewer || player.isYou ? THREE.MeshPhongMaterial : null,
              movT: tmpSkin.movT,
              sameGlow: tmpSkin.sameGlow,
              glowText: emGlow,
              noGreen: true,
              uv2: true,
              ao: isYou && !tmpWeap.noAo,
              shininess: tmpSkin.shine || tmpWeap.shine || 60,
              specular: 0x292929,
              transparent: tmpWeap.seeThrough,
              emissive: tmpWeap.transp || emGlow ? 0xffffff : null
            }, x == 1 ? -(tmpWeap.xOff * 2) : 0, 0, 0, Math.PI / 2, tmpWeap.scale, player.weaponMeshes[i]);
          }
        }
      }

      // LOAD FLAP:
      if (isYou && tmpWeap.flap && RENDER.sniperFlap) {
        player.weaponMeshes[i].flapMesh = RENDER.loadMesh({
          src: "attach/" + tmpWeap.flap.src,
          tFilter: THREE.LinearFilter,
          noGreen: true,
          mat: THREE.MeshPhongMaterial,
          shininess: 60,
          transparent: true
        }, tmpWeap.flap.xOff, tmpWeap.flap.yOff, tmpWeap.flap.zOff, Math.PI / 2, tmpWeap.flap.scl, player.weaponMeshes[i]);
      }

      // LOAD ATTACHMENT MODEL:
      if (tmpAttach && (isYou || viewer)) {
        RENDER.loadMesh({
          src: "attach/" + tmpAttach.src,
          tFilter: THREE.LinearFilter,
          noGreen: true,
          mat: player.isYou ? THREE.MeshPhongMaterial : null,
          specular: 0x292929,
          shininess: 60,
          transparent: true
        }, 0, -(tmpWeap.yOrg || 0) + (tmpWeap.attachYOff || 0), -(tmpWeap.attachZOff || 0), Math.PI / 2, tmpAttach.scale, player.weaponMeshes[i]);
      }
    }

    // LOWER BODY:
    player.objInstances.add(player.lowerBody);

    // ADD TO LAYER:
    if (isYou) {
      player.objInstances.traverse(function (c) {
        c.layers.set(1);
      });
    }

    // RETURN:
    return player.objInstances;
  };

  // REGENERATE MESHES:
  this.regenMeshes = function (player) {
    if (player.objInstances) {
      this.disposeMesh(player, true);
    }
    if (RENDER) {
      RENDER.add(this.generateMeshes(player, player.isYou));
    }
    this.swapWeapon(player, 0, true);
  };

  // HIDE:
  this.hideAll = function () {
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].active && this.list[i].objInstances) {
        this.list[i].forcePos = !this.list[i].latestData;
        this.list[i].latestData = false;
        if (!this.list[i].isYou) {
          this.list[i].objInstances.visible = false;
        }
      }
    }
  };

  // CLEAR ALL PLAYERS:
  this.clear = function () {
    if (RENDER) {
      for (var i = 0; i < this.list.length; ++i) {
        this.disposeMesh(this.list[i]);
      }
    }
    this.list.length = 0;
  };

  // TOGGLE LOD:
  this.toggleLOD = function (player, vis) {
    if (player.objInstances) {
      player.objInstances.visible = vis;
    }
    player.lodActive = !vis;
  };

  // DISPOSE PLAYER MESH:
  this.disposeMesh = function (player, refresh) {
    RENDER.remove(player.objInstances);
    player.objInstances = null;
    player.hatMesh = null;
    player.backMesh = null;
    player.weaponMeshes.length = 0;
    player.weaponGeos = {};
    player.armMeshes.length = 0;
    player.legMeshes.length = 0;
  };

  // ADD PLAYER:
  this.add = function (id, sid, x, y, z, name, classIndex, skins, hatIndex, backIndex, meleeIndex, secIndex, isYou, isHacker, customLoadout) {
    // GENERATE OBJECT:
    var tmpPlayer;
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].id == id) {
        tmpPlayer = this.list[i];
        break;
      }
    }
    if (!tmpPlayer) {
      tmpPlayer = new Player(id, this, UTILS, config, game);
      if (sid) {
        tmpPlayer.sid = sid;
      } else {
        tmpPlayer.sid = UTILS.generateSID(this.list);
      }
      this.list.push(tmpPlayer);
    } else {
      tmpPlayer.weaponMeshes.length = 0;
      tmpPlayer.weaponGeos = {};
      tmpPlayer.legMeshes.length = 0;
      tmpPlayer.armMeshes.length = 0;
    }

    // SETUP:
    if (!name) {
      name = "Guest_" + tmpPlayer.sid;
    }
    tmpPlayer.init(x, y, z, name, isYou, isHacker);
    if (io && game.mode != undefined) {
      this.setTeam(tmpPlayer);
    }
    tmpPlayer.skins = skins || [-1, -1];
    tmpPlayer.hatIndex = hatIndex;
    tmpPlayer.backIndex = backIndex;
    tmpPlayer.meleeIndex = meleeIndex;
    tmpPlayer.secIndex = secIndex;
    tmpPlayer.setClass(game, classIndex, secIndex, !!RENDER);
    if (!customLoadout && game.mode.startingLoadout) {
      customLoadout = game.mode.startingLoadout;
    }
    if (customLoadout) {
      tmpPlayer.updateLoadout(game, tmpPlayer.weaponIndex, false, ...customLoadout);
    }
    if (RENDER) {
      RENDER.add(this.generateMeshes(tmpPlayer, isYou));
    }
    this.swapWeapon(tmpPlayer, 0, true);
    if (typeof window !== 'undefined' && 'updateWindow' in window) {
      window.updateWindow(23);
    }
    return tmpPlayer;
  };

  // REMOVE PLAYER:
  this.remove = function (sid) {
    var tmpIndx = this.indexBySid(sid);
    if (tmpIndx >= 0) {
      if (io && this.list[tmpIndx]) {
        game.dropFlag(this.list[tmpIndx].flag);
        this.dropWeapon(this.list[tmpIndx], true);
      }
      var tmpRoom = this.list[tmpIndx].room;
      var tmpID = this.list[tmpIndx].id;
      if (this.list[tmpIndx].objInstances) {
        this.disposeMesh(this.list[tmpIndx]);
      }
      this.list.splice(tmpIndx, 1);
      if (io) {
        for (var i = this.list.length - 1; i >= 0; --i) {
          tmpIndx = this.list[i].sentTo.indexOf(tmpID);
          if (tmpIndx >= 0) {
            this.list[i].sentTo.splice(tmpIndx, 1);
          }
        }
        io.broadcast("game" + game.sid, "2", sid);
        this.syncLeaders();
      }
      if (typeof window !== 'undefined' && 'updateWindow' in window) {
        window.updateWindow(23);
      }
    }
  };

  // GET STEP SOUND:
  var stepSounds = [0, 1, 2];
  this.getStepSound = function () {
    var rand = UTILS.randInt(0, stepSounds.length - 1);
    var soundIndx = stepSounds[rand];
    stepSounds.splice(rand, 1);
    if (stepSounds.length <= 0) {
      stepSounds.push(0, 1, 2);
    }
    return soundIndx;
  };

  // PLAYER STEP:
  this.playerStep = function (player, val, prv) {
    if (val) {
      if (!player.isYou && player.crouchVal) {
        val *= 1.6;
      }
      player.stepVal += val * config.stepMlt * player.stepDir;
      if (player.stepVal >= Math.PI / 2 && player.stepDir == 1 || player.stepVal <= -Math.PI / 2 && player.stepDir == -1) {
        if (SOUND && !prv) {
          var stepVol = UTILS.randFloat(0.15, 0.25) * (player.crouchVal < 1 ? 1 : player.isYou ? 0.5 : 0);
          var stepRate = (player.crouchVal < 1 ? 1 : 0.8) * UTILS.randFloat(0.8, 1.2);
          var stepSrc = player.stepSrc ? "_" + player.stepSrc : "";
          if (player.isYou) {
            SOUND.play("step_" + this.getStepSound() + stepSrc, stepVol, false, stepRate);
          } else {
            if (stepVol) {
              game.playerSound("step_" + UTILS.randInt(0, 2) + stepSrc, 0, stepVol, player, stepRate, 180);
            }
          }
        }
        player.stepDir *= -1;
      }
    }
  };

  // RESET STEP:
  this.resetStep = function (player, recon) {
    if (!recon && player.isYou && player.yVel) {
      if (player.jumpTween) {
        player.jumpTween.stop();
      }
      if (player.landTween) {
        player.landTween.stop();
      }
      player.landTween = new TWEEN.Tween(player).to({
        landBobY: 6.0 * player.yVel,
        jumpBobY: 0
      }, 100).easing(TWEEN.Easing.Linear.None).onComplete(function () {
        player.landTween = new TWEEN.Tween(player).to({
          landBobY: 0
        }, 1100).easing(TWEEN.Easing.Elastic.Out).start();
      }).start();
    }
    if (SOUND && !recon && player.yVel) {
      var stepSrc = player.stepSrc ? "_" + player.stepSrc : "";
      SOUND.play("step_" + this.getStepSound(), 0.7, false, UTILS.randFloat(0.9, 1.2));
      if (player.isYou) {
        if (player.crouchVal && game.config.canSlide && player.canSlide) {
          SOUND.play("slide_0", 0.35, false, UTILS.randFloat(0.9, 1.1));
        }
      }
    }
    if (game.config.canSlide && player.crouchVal && player.canSlide) {
      player.canSlide = false;
      player.slideTimer = config.slideTime * player.crouchVal;
      var velMlt = this.onTerrain ? config.playerTerrainSlideVelMlt : config.playerSlideVelMlt;
      player.xVel *= velMlt;
      player.zVel *= velMlt;
    }
  };

  // TRY TO JUMP:
  this.tryJump = function (player, jKey) {
    if (game.config && game.config.autoJump && jKey) {
      this.jump(player);
    } else {
      if (player.didJump && !jKey) {
        player.didJump = false;
      }
      if (!player.didJump && jKey) {
        this.jump(player);
      }
    }
  };

  // JUMP:
  this.jump = function (player) {
    player.jumpCooldown = player.terrainSlipping ? config.playerSlippingJumpCooldown : 0;
    player.didJump = true;
    player.onTerrain = false;
    var jumpVel = config.jumpVel * (game.config ? game.config.jumpMlt : 1);
    var jumpPull = config.jumpPush * (game.config ? game.config.jumpMlt : 1);
    player.yVel += (jumpVel - jumpVel * (config.crouchJump * player.crouchVal)) * player.weapon.spdMlt * (player.aimVal ? 1 : config.aimJumpSlow);
    var tmpSpd = UTILS.getDistance(0, 0, player.xVel, player.zVel);
    player.xVel -= jumpPull * tmpSpd * Math.sin(player.xDire);
    player.zVel -= jumpPull * tmpSpd * Math.cos(player.xDire);
    if (SOUND && !player.recon && player.isYou) {
      if (player.landTween) {
        player.landTween.stop();
      }
      player.landTween = new TWEEN.Tween(player).to({
        landBobY: 0
      }, 100).easing(TWEEN.Easing.Linear.None).start();
      if (player.jumpTween) {
        player.jumpTween.stop();
      }
      player.jumpTween = new TWEEN.Tween(player).to({
        jumpBobY: 0.22
      }, 500).easing(TWEEN.Easing.Back.Out).start();
      var jRotV = UTILS.randFloat(0.12, 0.15);
      var tmpTween = new TWEEN.Tween(player).to({
        jumpRot: [jRotV, 0]
      }, 900).easing(TWEEN.Easing.Back.Out).start();
      SOUND.play("jump_" + UTILS.randInt(0, 1), 0.04, false, UTILS.randFloat(0.9, 1));
    }
  };

  // UPDATE AIM:
  this.updateAim = function (player, mlt) {
    RENDER.zoom(1 + (player.weapon.zoom - 1) * mlt);
  };

  // TOGGLE AIM:
  this.toggleAim = function (player, aim) {
    if (SOUND && !player.recon) {
      SOUND.play("aim_" + aim, 0.1);
    }
    if (!aim) {
      this.resetAim();
    }
    if (player.weapon.scope) {
      RENDER.zoom(aim ? player.weapon.zoom : 1);
      player.weaponMeshes[player.weaponIndex].visible = !game.hideWeapon[player.weaponIndex] && !aim;
      aimRecticle.style.opacity = aim ? 1 : 0;
    }
    var tmpAttach = game.attach[player.weapon.attach];
    if (tmpAttach) {
      aimDot.style.opacity = aim ? 1 : 0;
      var tmpSkin = game.store.skins[player.skins[player.weaponIndex]];
      var tmpSrc = "./textures/dots/" + (tmpSkin ? tmpSkin.dot || "dot_0" : "dot_0") + ".png";
      if (aimDot.src != tmpSrc) {
        aimDot.src = tmpSrc;
      }
    }
  };

  // RESET AIM:
  this.resetAim = function () {
    RENDER.zoom(1);
    aimRecticle.style.opacity = 0;
    aimDot.style.opacity = 0;
  };

  // RELOAD:
  this.reload = function (player) {
    if (!player.reloadTimer && player.ammos[player.weaponIndex] < player.weapon.ammo) {
      if (SOUND) {
        SOUND.play("reload_1", 0.25);
      }
      player.reloadTimer = player.weapon.reload;
      if (player.isYou) {
        this.cancelInspect(player);
      }
    }
  };

  // END RELOAD:
  this.endReload = function (weapon) {
    if (SOUND) {
      SOUND.play("reload_2" + (weapon.custReload || ""), 0.25);
    }
  };

  // UPDATE PLAYER AMMO:
  this.updatePlayerAmmo = function (player) {
    if (player.isYou) {
      ammoDisplay.style.display = "inline-block";
      ammoVal.innerHTML = (player.ammos[player.weaponIndex] || (player.weapon.melee ? "-" : 0)) + " <span id='ammoMax'> | " + (player.weapon.ammo || "-") + "</span>";
      if (player.ammos[player.weaponIndex] <= 0) {
        reloadMsg.innerHTML = "[R] Reload";
        reloadMsg.style.display = "block";
      } else {
        reloadMsg.style.display = "none";
      }
    }
  };

  // CANCEL INSPECT:
  this.cancelInspect = function (player) {
    player.inspecting = false;
    player.inspectX = 0;
  };

  // INSPECT WEAPON:
  this.wInspect = function (player) {
    if (player.inspecting) {
      this.cancelInspect(player);
    } else {
      if (!player.weapon.nInsp && !player.inspecting && player.aimVal == 1 && !player.reloadTimer) {
        player.inspecting = true;
      }
    }
  };

  // MELEE:
  this.melee = function (player) {
    player.reloads[player.weaponIndex] = player.weapon.rate;
    player.didShoot = true;
    if (player.isYou) {
      if (player.weapon.anim) {
        var tmpSkin = game.store.skins[player.meleeIndex] || {};
        player.weapon.anim(player, TWEEN, tmpSkin.animInd || 1);
      }
      if (player.weapon.sounds) {
        SOUND.play(player.weapon.sounds[UTILS.randInt(0, player.weapon.sounds.length - 1)], 0.1, false, UTILS.randFloat(0.9, 1.1));
      }
    }

    // HIT SCAN:
    var sdX = player.xDire;
    var sdY = player.yDire;
    tmpList.length = 0;
    var tmpDst = 0;
    var dx = 1 / (player.weapon.range * Math.sin(sdX + Math.PI) * Math.cos(sdY));
    var dz = 1 / (player.weapon.range * Math.cos(sdX + Math.PI) * Math.cos(sdY));
    var dy = 1 / (player.weapon.range * Math.sin(sdY));
    var startY = player.y + player.height - config.cameraHeight;

    // MAP OBJECTS:
    for (var i = 0; i < game.map.manager.objects.length; ++i) {
      tmpObj2 = game.map.manager.objects[i];
      if (tmpObj2.active && !tmpObj2.noShoot) {
        tmpDst = UTILS.lineInRect(player.x, player.z, startY, dx, dz, dy, tmpObj2.x - tmpObj2.width, tmpObj2.z - tmpObj2.length, tmpObj2.y - tmpObj2.height, tmpObj2.x + tmpObj2.width, tmpObj2.z + tmpObj2.length, tmpObj2.y + tmpObj2.height);
        if (tmpDst && tmpDst <= 1) {
          tmpList.push({
            obj: tmpObj2,
            dst: tmpDst
          });
        }
      }
    }

    // PLAYERS:
    if (io) {
      for (var i = 0; i < this.list.length; ++i) {
        if (this.list[i].active && player != this.list[i] && !(player.team && player.team == this.list[i].team)) {
          tmpObj2 = this.fetchState(this.list[i], player.ping);
          if (tmpObj2) {
            tmpDst = UTILS.lineInRect(player.x, player.z, startY, dx, dz, dy, tmpObj2.x - this.list[i].scale - config.hitBoxPad, tmpObj2.z - this.list[i].scale - config.hitBoxPad, tmpObj2.y, tmpObj2.x + this.list[i].scale + config.hitBoxPad, tmpObj2.z + this.list[i].scale + config.hitBoxPad, tmpObj2.y + this.list[i].height + config.hitBoxPad);
            if (tmpDst && tmpDst <= 1) {
              tmpList.push({
                player: true,
                obj: this.list[i],
                dst: tmpDst
              });
            }
          }
        }
      }
    }

    // HIT CLOSEST OBJ:
    var tmpRange = player.weapon.range;
    if (tmpList.length) {
      tmpList.sort(UTILS.orderByDst);
      var DMG = player.weapon.dmg;
      for (var i = 0; i < tmpList.length; ++i) {
        tmpObj2 = tmpList[i];
        tmpRange = player.weapon.range * tmpObj2.dst;
        if (io) {
          var headShot = false;
          var legShot = false;
          if (io && !game.waitTimers && tmpObj2.obj && tmpObj2.obj.health && !tmpObj2.player) {
            io.send(player.id, "4");
            tmpObj2.obj.health -= DMG;
            if (tmpObj2.obj.health <= 0) {
              tmpObj2.obj.active = false;
              tmpObj2.obj.health = 0;
              game.destObjs.push(tmpObj2.obj.uid);
              io.broadcast("game" + game.sid, "do", tmpObj2.obj.uid);
            }
          }

          // APPLY DAMAGE:
          if (tmpObj2.player || tmpObj2.obj && tmpObj2.obj.dummy) {
            // SMITE: force a lethal hit when the attacker has smite set.
            var meleeDMG = player.smite ? (tmpObj2.obj.maxHealth || DMG) + tmpObj2.obj.maxHealth : DMG;
            if (this.changeHealth(tmpObj2.obj, player, meleeDMG)) {
              if (player) {
                player.melees++;
                if (io) {
                  game.incStat("mk", player);
                }
              }
              this.kill(tmpObj2.obj, player, {});
            }
            DMG -= player.weapon.pierce != undefined ? player.weapon.dmg * config.materialDens["flesh"] * player.weapon.pierce : DMG;
          } else {
            break;
          }
          if (DMG <= 0) {
            break;
          }
        } else {
          break;
        }
      }
    }
  };

  // SHOOT:
  var tmpList = [];
  this.shoot = function (player, input) {
    var didHit = false;
    if (io) {
      game.incStat("s", player);
    }
    player.reloads[player.weaponIndex] = player.weapon.rate;
    // UNLIMITED AMMO: skip the ammo decrement when the flag is set.
    if (!player.unlimitedAmmo) {
      player.ammos[player.weaponIndex]--;
    }
    player.didShoot = true;
    this.updatePlayerAmmo(player);
    if (game.playSound) {
      var gClick = player.ammos[player.weaponIndex] / game.weapons[player.loadout[player.weaponIndex]].ammo;
      if (player.isYou && gClick <= 0.25 && !player.weapon.nRing) {
        game.playSound(player.weapon.sound, 0.85, player, false, UTILS.randFloat(0.9, 1.0) + 0.15 * (1 - gClick / 0.25));
      } else {
        game.playSound(player.weapon.sound, 0.85, player, false, UTILS.randFloat(0.9, 1.0));
      }
    }
    player.recoilForce += player.weapon.recoil;
    if (player.isYou) {
      if (game.controls && game.controls.gamepad.connected) {
        game.controls.gamepad.rumble(0, player.weapon.rumbleDur || 200, player.weapon.rumble || 0.5);
      }
      var tmpVl = UTILS.randInt(0, 1) ? -player.weapon.recoilR : player.weapon.recoilR;
      player.recoilX += tmpVl;
      player.recoilZ += tmpVl;
      if (player.recoilTween) {
        player.recoilTween.stop();
      }
      var tweenTime = player.weapon.recoilAnim ? player.weapon.recoilAnim.time || player.weapon.rate : player.weapon.rate;
      if (player.aimVal == 0 && player.weapon.recoilAnim && player.weapon.recoilAnim.aimTime) {
        tweenTime = player.weapon.recoilAnim.aimTime;
      }
      player.recoilTween = new TWEEN.Tween(player).to(player.weapon.recoilAnim || {}, tweenTime * 0.15).easing(TWEEN.Easing.Linear.None).onComplete(function () {
        player.recoilTween = new TWEEN.Tween(player).to({
          recoilTweenY: 0,
          recoilTweenYM: 0,
          recoilTweenZ: 0
        }, tweenTime * 0.95).easing(TWEEN.Easing.Back.Out).start();
      }).start();
      this.cancelInspect(player);
    }

    // PARTICLES:
    if (player.isYou && !game.hideWeapon[player.weaponIndex]) {
      var tmpMesh = player.weaponMeshes[player.weaponIndex];
      var scopedIn = player.aimVal == 0 && player.weapon.scope;
      if (PARTICLES.showMuzzle && !player.weapon.nMuz && (RENDER.useDepthMap == 0 || RENDER.useDepthMap == "0")) {
        for (var x = 0; x < tmpMesh.muzzles.length; ++x) {
          tmpMesh.muzzles[x].visible = true;
          PARTICLES.setMaterial(tmpMesh.muzzles[x], player.weapon.muzID || 2, 1, true);
          tmpMesh.muzzles[x].init(x ? -(player.weapon.xOff * 2) : 0, player.weapon.muzOffY || 0, -player.weapon.muzOff, 0, 0, 0, 4 * (player.weapon.muzMlt || 1), 1);
        }
        if (!scopedIn) {
          var tmpPos = player.weaponMeshes[player.weaponIndex].muzzles[0].getWorldPosition().clone();
          tmpPos.project(RENDER.camera);
          tmpPos.x = (tmpPos.x + 1) / 2;
          tmpPos.y = (tmpPos.y + 1) / 2;
          RENDER.flash(tmpPos.x, tmpPos.y);
        }
      }
      if (!player.weapon.nCase && PARTICLES.active) {
        for (var x = 0; x < player.weaponMeshes[player.weaponIndex].casings.length; ++x) {
          var tmpPos = player.weaponMeshes[player.weaponIndex].casings[x].getWorldPosition();
          if (SOUND && game.now - (player.lastShell || 0) > 400) {
            player.lastShell = game.now;
            SOUND.play3D("case_" + UTILS.randInt(0, 1), tmpPos.x, tmpPos.y, tmpPos.z, 0.65, UTILS.randFloat(0.8, 1.3));
          }
          if (!scopedIn) {
            var randM = UTILS.randInt(0, 1) ? 1.4 : 0.8;
            PARTICLES.physObj(tmpPos.x, tmpPos.y, tmpPos.z, player.xDire - Math.PI / 2 * (x ? -1 : 1), Math.PI / 5 * UTILS.randFloat(0.75, 1.2) * randM, 25, false, player.weapon.caseInd || 1, player);
          }
        }
      }
    }

    // PROJECTILE:
    if (player.weapon.projectile != undefined) {
      if (io) {
        var tmpSpr = (player.spread + (player.weapon.innac || 0)) * config.spreadAdj;
        var sdX = player.xDire + UTILS.randFloat(-tmpSpr, tmpSpr);
        var sdY = player.yDire + player.recoilAnimY * config.recoilMlt + UTILS.randFloat(-tmpSpr, tmpSpr);
        game.projectiles.init(player.x, player.y + player.height - config.cameraHeight, player.z, sdX, sdY, player.weapon.projectile, player);
      }
    } else {
      // HIT SCAN:
      for (var s = player.weapon.physPow ? -1 : 0; s < (player.weapon.shots || 1); ++s) {
        // SPREAD:
        var tmpSpr = s >= 0 ? (player.spread + (player.weapon.innac || 0)) * config.spreadAdj : 0;
        var sdX = player.xDire + UTILS.randFloat(-tmpSpr, tmpSpr);
        var sdY = player.yDire + player.recoilAnimY * config.recoilMlt + UTILS.randFloat(-tmpSpr, tmpSpr);

        // RANGE:
        var weapRange = player.weapon.range;
        if (s < 0) {
          weapRange = player.weapon.physRang;
        }

        // BULLET COLLISION:
        tmpList.length = 0;
        var tmpDst = 0;
        var dx = 1 / (weapRange * Math.sin(sdX + Math.PI) * Math.cos(sdY));
        var dz = 1 / (weapRange * Math.cos(sdX + Math.PI) * Math.cos(sdY));
        var dy = 1 / (weapRange * Math.sin(sdY));

        // START POSITION:
        var startY = player.y + player.height - config.cameraHeight;

        // MAP OBJECTS:
        for (var i = 0; i < game.map.manager.objects.length; ++i) {
          tmpObj2 = game.map.manager.objects[i];
          if (tmpObj2.active && !tmpObj2.noShoot) {
            tmpDst = UTILS.lineInRect(player.x, player.z, startY, dx, dz, dy, tmpObj2.x - tmpObj2.width, tmpObj2.z - tmpObj2.length, tmpObj2.y - tmpObj2.height, tmpObj2.x + tmpObj2.width, tmpObj2.z + tmpObj2.length, tmpObj2.y + tmpObj2.height);
            if (tmpDst && tmpDst <= 1) {
              tmpList.push({
                obj: tmpObj2,
                dst: tmpDst
              });
            }
          }
        }

        // PLAYERS:
        if (io && s >= 0) {
          for (var i = 0; i < this.list.length; ++i) {
            if (this.list[i].active && player != this.list[i] && !(player.team && player.team == this.list[i].team)) {
              tmpObj2 = this.fetchState(this.list[i], player.ping);
              if (tmpObj2) {
                tmpDst = UTILS.lineInRect(player.x, player.z, startY, dx, dz, dy, tmpObj2.x - this.list[i].scale - config.hitBoxPad, tmpObj2.z - this.list[i].scale - config.hitBoxPad, tmpObj2.y, tmpObj2.x + this.list[i].scale + config.hitBoxPad, tmpObj2.z + this.list[i].scale + config.hitBoxPad, tmpObj2.y + this.list[i].height + config.hitBoxPad);
                if (tmpDst && tmpDst <= 1) {
                  tmpList.push({
                    player: true,
                    obj: this.list[i],
                    dst: tmpDst
                  });
                }
              }
            }
          }
        }

        // TERRAIN:
        var terrain = game.map.terrain;
        if (terrain) {
          var terrainRaycast = terrain.raycast(player.x, -player.z, startY, 1 / dx, -1 / dz, 1 / dy);
          if (terrainRaycast) {
            let dst = UTILS.getDistance3D(player.x, startY, player.z, terrainRaycast.x, terrainRaycast.z, -terrainRaycast.y);
            tmpList.push({
              terrain: true,
              dst: dst / weapRange
            });
          }
        }

        // HIT CLOSEST OBJ:
        var tmpRange = weapRange;
        if (tmpList.length) {
          tmpList.sort(UTILS.orderByDst);
          var DMG = player.weapon.dmg;
          for (var i = 0; i < tmpList.length; ++i) {
            tmpObj2 = tmpList[i];
            tmpRange = weapRange * tmpObj2.dst;
            if (s < 0) {
              var impulse = (1 - tmpObj2.dst) * (player.weapon.physPow * (game.config ? game.config.impulseMlt : 1));
              var tXV = impulse * Math.sin(sdX + Math.PI) * Math.cos(sdY);
              player.xVel -= tXV;
              var tYV = impulse * Math.cos(sdX + Math.PI) * Math.cos(sdY);
              player.zVel -= tYV;
              var tZV = impulse * Math.sin(sdY);
              player.yVel -= tZV;
              player.onGround = false;
              if (!io) {
                input.velObj = {
                  x: tXV,
                  y: tYV,
                  z: tZV
                };
              }
              break;
            } else {
              if (io) {
                // CALCULATE DAMAGE:
                var dropStart = player.weapon.dropStart || 0;
                var tmpDrop = Math.min(1, 1 - (1 - tmpObj2.dst) * weapRange / (weapRange - dropStart));
                var tmpDMG = DMG - player.weapon.dmgDrop * tmpDrop;
                var headShot = false;
                var legShot = false;
                if (tmpObj2.player) {
                  var hitY = startY + tmpRange * Math.sin(sdY);
                  headShot = tmpObj2.obj.y + tmpObj2.obj.height - hitY < config.headScale;
                  legShot = tmpObj2.obj.y + config.legHeight > hitY;
                  tmpDMG *= headShot && !player.weapon.noHeadShot ? 1.5 : 1;
                  tmpDMG *= legShot ? 0.5 : 1;
                  if (!headShot && (game.config ? game.config.headshotOnly : false)) {
                    tmpDMG = 0;
                  }
                }

                // DESTRUCTABLE OBJECT:
                if (io && !game.waitTimers && tmpObj2.obj && tmpObj2.obj.health && !tmpObj2.player) {
                  tmpObj2.obj.health -= tmpDMG;
                  io.send(player.id, "4");
                  if (tmpObj2.obj.health <= 0) {
                    tmpObj2.obj.active = false;
                    tmpObj2.obj.health = 0;
                    game.destObjs.push(tmpObj2.obj.uid);
                    io.broadcast("game" + game.sid, "do", tmpObj2.obj.uid);
                  }
                }

                // APPLY DAMAGE:
                if (tmpObj2.player || tmpObj2.obj && tmpObj2.obj.dummy) {
                  if (tmpObj2.player) {
                    didHit = true;
                  }
                  // SMITE: force a lethal hit when the shooter has smite set.
                  var shotDMG = player.smite ? (tmpObj2.obj.maxHealth || tmpDMG) + tmpObj2.obj.maxHealth : tmpDMG;
                  if (this.changeHealth(tmpObj2.obj, player, shotDMG)) {
                    var killData = {
                      dst: tmpObj2.dst,
                      headShot: headShot
                    };
                    this.kill(tmpObj2.obj, player, killData);
                  }
                  DMG -= player.weapon.pierce != undefined ? player.weapon.dmg * config.materialDens["flesh"] * player.weapon.pierce : DMG;
                } else {
                  if (tmpObj2.obj && tmpObj2.obj.penetrable) {
                    DMG -= player.weapon.pierce != undefined ? player.weapon.dmg * config.materialDens["default"] * player.weapon.pierce : DMG;
                  } else {
                    break;
                  }
                }
                if (DMG <= 0) {
                  break;
                }
              } else {
                break;
              }
            }
          }
        }

        // HIT LOCATION:
        tmpRange -= 0.12;
        var hitX = player.x + tmpRange * Math.sin(sdX + Math.PI) * Math.cos(sdY);
        var hitY = startY + tmpRange * Math.sin(sdY);
        var hitZ = player.z + tmpRange * Math.cos(sdX + Math.PI) * Math.cos(sdY);
        var xDr = 0;
        var yDr = 0;

        // IMPACT ANIMATION & PARTICLES:
        if (tmpList.length) {
          if (tmpObj2.terrain) {
            yDr = Math.PI / 2;
          } else {
            if (hitY >= tmpObj2.obj.y + tmpObj2.obj.height) {
              yDr = Math.PI / 2;
            } else {
              if (hitY <= tmpObj2.obj.y - tmpObj2.obj.height) {
                yDr = -Math.PI / 2;
              } else {
                if (hitX <= tmpObj2.obj.x - tmpObj2.obj.width) {
                  xDr = -Math.PI / 2;
                } else {
                  if (hitX >= tmpObj2.obj.x + tmpObj2.obj.width) {
                    xDr = Math.PI / 2;
                  } else {
                    if (hitZ <= tmpObj2.obj.z - tmpObj2.obj.length) {
                      xDr = Math.PI;
                    }
                  }
                }
              }
            }
          }
          if (!io) {
            PARTICLES.effect(hitX, hitY, hitZ, xDr, yDr, 0);
          }
        }
        if (io) {
          var sendTrail = player.weapon && player.weapon.trail ? 1 : 0;
          for (var i = 0; i < this.list.length; ++i) {
            if ((this.list[i].active || this.list[i].spectating) && this.list[i] != player) {
              if (tmpList.length && !tmpObj2.player) {
                io.send(this.list[i].id, "9", player.sid, Math.round(hitX), Math.round(hitY), Math.round(hitZ), xDr.round(1), yDr.round(1), sendTrail);
              } else {
                io.send(this.list[i].id, "9", player.sid, Math.round(hitX), Math.round(hitY), Math.round(hitZ), undefined, undefined, sendTrail);
              }
            }
          }
        }

        // TRACER:
        if (player.isYou && tmpRange >= config.tracerMinDst) {
          var randMuz = UTILS.randInt(0, player.weaponMeshes[player.weaponIndex].muzzles.length - 1);
          var tmpPos = player.weaponMeshes[player.weaponIndex].muzzles[randMuz].getWorldPosition();
          var extender = player.weapon && player.weapon.scope && player.aimVal == 0 ? 7 : 0;
          var tX = tmpPos.x - extender * Math.sin(sdX + Math.PI) * Math.cos(sdY);
          ;
          var tY = tmpPos.y - extender * Math.sin(sdY);
          ;
          var tZ = tmpPos.z - extender * Math.cos(sdX + Math.PI) * Math.cos(sdY);
          ;
          var td = UTILS.getDistance3D(tX, tY, tZ, hitX, hitY, hitZ);
          var xDr = UTILS.getDirection(tZ, tX, hitZ, hitX);
          var yDr = UTILS.getDirection(UTILS.getDistance(tX, tZ, hitX, hitZ), hitY, 0, tY);
          PARTICLES.physObj(tX, tY, tZ, xDr, yDr, Math.min(tmpRange + extender, config.tracerMaxDst), player.weapon && player.weapon.trail, 0, player);
        }
      }
    }
    if (didHit && io) {
      game.incStat("h", player);
    }
  };

  // SPRAY:
  this.spray = function (player) {
    if (game.now - player.lastSpray >= config.sprayTimer) {
      tmpList.length = 0;
      var tmpDst = 0;
      var dx = 1 / (config.sprayRange * Math.sin(player.xDire + Math.PI) * Math.cos(player.yDire));
      var dz = 1 / (config.sprayRange * Math.cos(player.xDire + Math.PI) * Math.cos(player.yDire));
      var dy = 1 / (config.sprayRange * Math.sin(player.yDire));
      for (var i = 0; i < game.map.manager.objects.length; ++i) {
        tmpObj2 = game.map.manager.objects[i];
        if (!tmpObj2.noShoot && !tmpObj2.noVis) {
          tmpDst = UTILS.lineInRect(player.x, player.z, player.y + player.height - config.cameraHeight, dx, dz, dy, tmpObj2.x - tmpObj2.width, tmpObj2.z - tmpObj2.length, tmpObj2.y - tmpObj2.height, tmpObj2.x + tmpObj2.width, tmpObj2.z + tmpObj2.length, tmpObj2.y + tmpObj2.height);
          if (tmpDst && tmpDst <= 1) {
            tmpList.push({
              obj: tmpObj2,
              dst: tmpDst
            });
          }
        }
      }
      if (tmpList.length) {
        tmpList.sort(UTILS.orderByDst);
        tmpObj2 = tmpList[0].obj;
        if (tmpObj2) {
          var tmpRange = config.sprayRange * tmpList[0].dst - 0.1;
          var hitY = player.y + player.height - config.cameraHeight + tmpRange * Math.sin(player.yDire);
          var hitX = player.x + tmpRange * Math.sin(player.xDire + Math.PI) * Math.cos(player.yDire);
          var hitZ = player.z + tmpRange * Math.cos(player.xDire + Math.PI) * Math.cos(player.yDire);
          var xDr = 0;
          var yDr = 0;
          if (hitY >= tmpObj2.y + tmpObj2.height) {
            yDr = -90;
          } else {
            if (hitY <= tmpObj2.y - tmpObj2.height) {
              yDr = 90;
            } else {
              if (hitX <= tmpObj2.x - tmpObj2.width) {
                xDr = -90;
              } else {
                if (hitX >= tmpObj2.x + tmpObj2.width) {
                  xDr = 90;
                } else {
                  if (hitZ <= tmpObj2.z - tmpObj2.length) {
                    xDr = 180;
                  }
                }
              }
            }
          }
          var tS = config.sprayScale / 2;
          if (yDr) {
            if (tmpObj2.width < tS || tmpObj2.length < tS) {
              return;
            }
            if (hitZ - tS < tmpObj2.z - tmpObj2.length) {
              hitZ = tmpObj2.z - tmpObj2.length + tS;
            } else {
              if (hitZ + tS > tmpObj2.z + tmpObj2.length) {
                hitZ = tmpObj2.z + tmpObj2.length - tS;
              }
            }
            if (hitX - tS < tmpObj2.x - tmpObj2.width) {
              hitX = tmpObj2.x - tmpObj2.width + tS;
            } else {
              if (hitX + tS > tmpObj2.x + tmpObj2.width) {
                hitX = tmpObj2.x + tmpObj2.width - tS;
              }
            }
          } else {
            if (tmpObj2.height < tS) {
              return;
            }
            if (xDr == 90 || xDr == -90) {
              if (tmpObj2.length < tS) {
                return;
              }
              if (hitZ - tS < tmpObj2.z - tmpObj2.length) {
                hitZ = tmpObj2.z - tmpObj2.length + tS;
              } else {
                if (hitZ + tS > tmpObj2.z + tmpObj2.length) {
                  hitZ = tmpObj2.z + tmpObj2.length - tS;
                }
              }
            } else {
              if (tmpObj2.width < tS) {
                return;
              }
              if (hitX - tS < tmpObj2.x - tmpObj2.width) {
                hitX = tmpObj2.x - tmpObj2.width + tS;
              } else {
                if (hitX + tS > tmpObj2.x + tmpObj2.width) {
                  hitX = tmpObj2.x + tmpObj2.width - tS;
                }
              }
            }
            if (hitY + tS > tmpObj2.y + tmpObj2.height) {
              hitY = tmpObj2.y + tmpObj2.height - tS;
            }
          }
          player.lastSpray = game.now;
          if (game.playSound) {
            game.playSound("spray", 0.4, player, true);
          }
          io.broadcast("game" + game.sid, "sp", player.sid, player.sprayIndex, hitX.round(2), hitY.round(2), hitZ.round(2), xDr, yDr);
        }
      }
    }
  };

  // INTERACT:
  this.interact = function (player) {
    if (game.now - player.lastPickup >= config.pickupTimer && player.team != "inf") {
      player.lastPickup = game.now;
      for (var i = 0; i < game.map.manager.pickups.length; ++i) {
        tmpObj = game.map.manager.pickups[i];
        if (tmpObj.pickup != undefined && player.collides(tmpObj) && player.loadout.indexOf(tmpObj.pickup) == -1) {
          // ONLY HAS MELEE & IS TRYING TO PICKUP ANYTHING
          if (game.weapons[player.loadout[0]] && game.weapons[player.loadout[0]].melee && player.loadout.length == 1) {
            tmpObj2 = undefined;
            player.loadout[0] = tmpObj.pickup;
            player.weaponIndex = 0;
            if (tmpObj.pickupRep && tmpObj2 == undefined) {
              this.addPicked(player, tmpObj.pickup);
            }
          } else {
            if (game.weapons[tmpObj.pickup].type) {
              // TRYING TO PICKUP SECONDARY

              // ONLY HAS SECONDARY & TRYING TO PICKUP SECONDARY
              if (game.weapons[player.loadout[0]].type) {
                tmpObj2 = player.loadout[0];
                player.loadout[0] = tmpObj.pickup;
                player.weaponIndex = 0;

                // HAS PRIMARY & TRYING TO PICKUP OR SWAP SECONDARY
              } else {
                if (!game.weapons[player.loadout[0]].type) {
                  // PRIMARY
                  tmpObj2 = game.weapons[player.loadout[1]] && game.weapons[player.loadout[1]].melee ? undefined : player.loadout[1];
                  player.loadout[1] = tmpObj.pickup;
                  player.weaponIndex = 1;
                }
              }
              this.removePicked(player, tmpObj2);
              if (tmpObj.pickupRep && tmpObj2 == undefined) {
                this.addPicked(player, tmpObj.pickup);
              }
            } else {
              if (!game.weapons[tmpObj.pickup].type) {
                // TRYING TO PICKUP PRIMARY
                tmpObj2 = game.weapons[player.loadout[0]] && game.weapons[player.loadout[0]].melee ? undefined : player.loadout[0];
                var wasDropable = false;

                // ONLY HAS SECONDARY & TRYING TO PICKUP PRIMARY
                if (game.weapons[player.loadout[0]].type) {
                  player.loadout.splice(0, 0, tmpObj.pickup);
                  if (game.weapons[player.loadout[1]] && game.weapons[player.loadout[1]].melee) {
                    player.loadout.length = 1;
                  }
                  tmpObj2 = undefined;

                  // HAS PRIMARY & TRYING TO SWAP PRIMARY
                } else {
                  if (!game.weapons[player.loadout[0]].type) {
                    if (!(game.weapons[player.loadout[0]] && game.weapons[player.loadout[0]].melee)) {
                      wasDropable = this.removePicked(player, player.loadout[0]);
                    }
                    player.loadout[0] = tmpObj.pickup;
                  }
                }
                if (tmpObj.pickupRep && (tmpObj2 == undefined || wasDropable)) {
                  this.addPicked(player, tmpObj.pickup);
                }
                player.weaponIndex = 0;
              }
            }
          }
          if (tmpObj.pickupRep) {
            tmpObj.pickup = tmpObj2;
          }
          io.broadcast("game" + game.sid, "inat", player.sid, player.loadout, player.weaponIndex, tmpObj.uid, tmpObj.pickupRep ? tmpObj2 : tmpObj.pickup);
          player.updateLoadout(game, player.weaponIndex, true, ...player.loadout);
          break;
        }
      }
    }
  };
  this.findEmptyPickup = function () {
    var tmp;
    for (var i = 0; i < game.map.manager.pickups.length; ++i) {
      tmp = game.map.manager.pickups[i];
      if (tmp.pickupRep && tmp.pickup == undefined) {
        return tmp.uid;
      }
    }
    return null;
  };
  this.addPicked = function (player, wid) {
    var index = player.lastPicked.indexOf(wid);
    if (index == -1) {
      player.lastPicked.push(wid);
    }
  };
  this.removePicked = function (player, wid) {
    var index = player.lastPicked.indexOf(wid);
    if (index > -1) {
      player.lastPicked.splice(index, 1);
    }
    return index > -1;
  };
  this.dropWeapon = function (player, died) {
    if (!game.map.manager.pickups.length) {
      return;
    }
    var index = player.weaponIndex;
    var drop = player.loadout[index];
    var tmp;
    var cords = [player.x + UTILS.randInt(-5, 5), player.y + 1, player.z + UTILS.randInt(-5, 5)];
    if (died) {
      for (var i = 0; i < player.loadout.length; i++) {
        drop = player.loadout[i];
        tmp = this.findEmptyPickup();
        if (tmp && player.lastPicked.indexOf(drop) > -1 && !game.weapons[drop].melee) {
          cords = [player.x + UTILS.randInt(-5, 5), player.y + 1, player.z + UTILS.randInt(-5, 5)];
          game.updatePickup(tmp, drop, null, cords);
          io.broadcast("game" + game.sid, "inat", null, null, null, tmp, drop, true, cords);
        }
      }
      player.lastPicked.length = 0;
    } else {
      if (!game.weapons[drop].melee) {
        tmp = this.findEmptyPickup();
        var pickup = tmp && player.lastPicked.indexOf(drop) > -1;
        if (pickup) {
          this.removePicked(player, drop);
          game.updatePickup(tmp, drop, null, cords);
        }
        player.loadout = player.loadout.length == 1 ? [] : [player.loadout[index ? 0 : 1]];
        player.weaponIndex = 0;
        io.broadcast("game" + game.sid, "inat", player.sid, player.loadout, player.weaponIndex, tmp, drop, pickup, cords);
        player.updateLoadout(game, player.weaponIndex, true, ...player.loadout);
      }
    }
  };
  this.updateInteract = function (player, dis) {
    if (!game.map.manager.pickups.length) {
      return;
    }
    if (player.isYou) {
      var inner = "Press [" + UTILS.getKeyName(parseInt(getSavedVal("cont_interactKey") || 71)) + "] to pickup";
      var vis = dis ? "block" : "none";
      if (interactMsg.innerHTML != inner) {
        interactMsg.innerHTML = inner;
      }
      if (interactMsg.style.display != vis) {
        interactMsg.style.display = vis;
      }
    }
  };

  // SYNC LEADERBOARD:
  var tmpLeaders = [];
  this.syncLeaders = function () {
    if (game.mode.killSort) {
      tmpData = this.list.slice().sort(UTILS.orderByKills);
    } else {
      tmpData = this.list.slice().sort(UTILS.orderByScore);
    }
    tmpLeaders.length = 0;
    var tmpC = 0;
    var specC = 0;
    for (var i = 0; i < tmpData.length; ++i) {
      if (!tmpData[i].spectating) {
        if (tmpC < 10) {
          tmpC++;
          tmpLeaders.push(tmpData[i].sid, tmpData[i].account ? tmpData[i].account.name : tmpData[i].name, tmpData[i].team, game.mode.killSort ? tmpData[i].kills : tmpData[i].score, tmpData[i].account ? tmpData[i].account.clan : 0, tmpData[i].account ? tmpData[i].account.featured : 0);
        }
      } else {
        specC++;
      }
    }
    io.broadcast("game" + game.sid, "7", tmpLeaders, specC);
  };

  // SCORE:
  this.score = function (player, amount, fromKill) {
    if (io) {
      // YOUR SCORE:
      player.score += amount;
      io.send(player.id, "5", amount);
      this.syncLeaders();

      // TEAM SCORE:
      if (game.mode.teams && player.team && game.teams && !game.mode.noScoreC && !(fromKill && game.mode.objective)) {
        if (!game.teams[player.team]) {
          game.teams[player.team] = amount;
        } else {
          game.teams[player.team] += amount;
        }
        io.broadcast("game" + game.sid, "ts", player.team, game.teams[player.team]);
      }
    }
  };

  // TICK PLAYER:
  this.tickPlayer = function (player, delta) {
    player.playTime += delta;
    if (player.hitTimer > 0) {
      player.hitTimer -= delta;
    }
    player.ticker -= delta;
    if (player.ticker <= 0) {
      player.ticker = 500;
      if (player.hitTimer <= 0 && !player.challMode) {
        this.changeHealth(player, null, -(player.maxHealth * (player.regen || 0)));
      }
    }
  };

  // CHANGE HEALTH:
  this.changeHealth = function (getter, doer, val, force) {
    if (game.waitTimers && !game.waitTimers[0].canDMG) {
      return;
    }
    if (val < 0 && getter.health == getter.maxHealth) {
      return;
    }
    // GOD MODE: block incoming damage (positive val). Healing still applies.
    if (getter.godMode && val > 0) {
      return;
    }

    // HACK CHECK:
    if (doer && doer.account && doer.account.hack && val) {
      val *= 0.2;
    }
    if (doer && doer.avgSpn >= 0.1) {
      val *= 0.2;
    }
    if (doer && doer.isHacker) {
      val *= 0.1;
    }
    if (doer && doer.lastHack && game.now - doer.lastHack <= 300) {
      if (doer.hackSus >= 3) {
        val *= 0.4;
      } else {
        doer.hackSus++;
      }
      doer.lastHack = 0;
    }

    // CONTINUE:
    if (!force && getter.team && doer && getter.team == doer.team && val > 0) {
      return;
    }
    if (doer && doer != getter && val > 0) {
      io.send(doer.id, "4");
    }
    if (getter.dummy) {
      return true;
    }
    if (val > 0) {
      getter.hitTimer = getter.regenDelay || 0;
    }
    getter.health -= val;
    getter.health = Math.max(Math.min(getter.maxHealth, getter.health), 0);
    if (doer) {
      io.send(getter.id, "h", Math.ceil(getter.health), null, Math.round(doer.x), Math.round(doer.z));
      if (doer != getter) {
        if (!getter.dmgReceived[doer.id]) {
          getter.dmgReceived[doer.id] = {
            time: game.now,
            val: val
          };
        } else {
          getter.dmgReceived[doer.id].val += val;
          getter.dmgReceived[doer.id].time = game.now;
        }
      }
    } else {
      io.send(getter.id, "h", Math.ceil(getter.health));
    }
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i] != getter) {
        io.send(this.list[i].id, "h", Math.ceil(getter.health), getter.sid);
      }
    }
    return getter.health <= 0;
  };

  // SWAP MELEE:
  this.swapMelee = function (player, recon) {
    if (player.ammos.length <= 1) {
      return;
    }
    if (player.weaponIndex != player.ammos.length - 1) {
      this.swapWeapon(player, null, null, undefined, player.ammos.length - 1, recon);
    } else {
      this.swapWeapon(player, 1, false, undefined, undefined, recon);
    }
  };

  // SWAP SECONDARY:
  this.swapSecondary = function (player, recon) {
    if (player.ammos.length <= 1) {
      return;
    }
    for (var i = 0; i < player.ammos.length; ++i) {
      var tmpIn = player.loadout[i];
      if (game.weapons[tmpIn] && game.weapons[tmpIn].secondary) {
        if (player.weaponIndex != i) {
          this.swapWeapon(player, null, null, undefined, i, recon);
        } else {
          this.swapWeapon(player, null, null, undefined, 0, recon);
        }
      }
    }
  };

  // SWAP WEAPON:
  this.swapWeapon = function (player, dir, force, set, lSet, recon) {
    if (player.ammos.length <= 1 && dir || set > player.ammos.length) {
      return;
    }
    var lastIndex = player.weaponIndex;
    if (dir) {
      if (dir != 1 && dir != -1) {
        dir = 0;
      }
      player.weaponIndex += dir;
      if (dir == 1) {
        if (player.weaponIndex > player.ammos.length - 2) {
          player.weaponIndex = 0;
        }
      } else {
        if (player.weaponIndex < 0) {
          player.weaponIndex = Math.min(player.ammos.length - 1, 2);
        } else {
          player.weaponIndex = 0;
        }
      }
    }
    if (set != undefined) {
      player.weaponIndex = set;
    }
    if (lSet != undefined) {
      player.weaponIndex = lSet;
    }
    if ((dir != undefined || lSet != undefined) && (lastIndex != player.weaponIndex || force)) {
      player.reloadTimer = 0;
      player.didShoot = false;
    }
    player.weapon = game.weapons[player.loadout[player.weaponIndex]];
    if (!player.weapon) {
      player.weapon = game.weapons[player.loadout[0]];
      if (player.weapon) {
        player.weaponIndex = 0;
      }
    }
    if (RENDER && (lastIndex != player.weaponIndex || force)) {
      this.cancelInspect(player);
      for (var i = 0; i < player.weaponMeshes.length; ++i) {
        player.weaponMeshes[i].visible = false;
      }
      if (player.weaponMeshes[player.weaponIndex]) {
        player.weaponMeshes[player.weaponIndex].visible = !game.hideWeapon[player.weaponIndex] || !player.isYou;
      }
    }
    if (set == undefined && player.weapon && !(RENDER && !player.isYou)) {
      if (!(player.isYou && lastIndex == player.weaponIndex) && !recon) {
        player.swapTime = player.weapon.swapTime;
      }
      if (player.isYou && (lastIndex != player.weaponIndex || force)) {
        var tmpHTML = "";
        for (var i = 0; i < player.ammos.length; ++i) {
          var isActive = i == player.weaponIndex;
          if (game.weapons[player.loadout[i]].icon) {
            tmpHTML += "<div class='weaponItem'>" + (i > 0 ? "<div class='weapKey'>" + (game.weapons[player.loadout[i]].melee ? "[" + UTILS.getKeyName(game.controls.meleeKey) + "]" : "[" + UTILS.getKeyName(game.controls.swapKey) + "]") + "</div>" : "") + "<img style='opacity:" + (isActive ? 1 : 0.7) + (i ? ";margin-right:25px" : "") + "' class='weaponIcon' src='" + (game.weapons[player.loadout[i]].melee ? "./textures/melee/icon_" + (game.store.skins[player.meleeIndex] ? game.store.skins[player.meleeIndex].id || 0 : 0) : "./textures/weapons/" + game.weapons[player.loadout[i]].icon) + ".png' /></div>";
          }
        }

        // DONT DO ON RECON:
        if (!recon) {
          // FLAP ANIM:
          if (player.swapTween) {
            player.swapTween.stop();
          }
          player.swapTweenA = 0.5;
          player.swapTween = new TWEEN.Tween(player).to({
            swapTweenA: 1
          }, 1200).easing(TWEEN.Easing.Elastic.Out).start();

          // WEAPON SWAP ROT ANIM:
          if (lastIndex != player.weaponIndex && player.aimVal == 1) {
            if (player.swapTweenAnim) {
              player.swapTweenAnim.stop();
            }
            player.swapTweenR = player.weapon.swapWiggle || 0.6;
            player.swapTweenAnim = new TWEEN.Tween(player).to({
              swapTweenR: 0
            }, player.weapon.swapTime + 220).easing(TWEEN.Easing.Back.InOut).start();
          }

          // MELEE SWAP ANIM:
          if (lastIndex != player.weaponIndex && player.aimVal == 1) {
            if (player.meleeAnim.anim) {
              player.meleeAnim.anim.stop();
            }
            player.resetMeleeAnim();
            player.meleeAnim.armR = 0.15;
            if (player.weapon.melee) {
              player.meleeAnim.anim = new TWEEN.Tween(player.meleeAnim).to({
                armR: 0
              }, 700).easing(TWEEN.Easing.Back.InOut).start();
            }
          }
        }

        // UPDATE GUI:
        weaponDisplay.innerHTML = tmpHTML;
        this.updatePlayerAmmo(player);
      }
    }
  };

  // CHECK KILL STREAK:
  this.checkStreak = function (player) {
    for (var i = 0; i < game.streaks.length; ++i) {
      if (player.killStreak == game.streaks[i].kills) {
        this.addStreak(player, i);
      }
    }
  };

  // REMOVE STREAK:
  this.useStreak = function (player, index) {
    if (player.streaks[index] && player.streaks[index].activate(game, player)) {
      player.streaks[index] = null;
      io.send(player.id, "st", index, 1);
    }
  };

  // ADD STREAK TO PLAYER:
  this.addStreak = function (player, index) {
    if (!player.streaks[index]) {
      player.streaks[index] = game.streaks[index];
      io.send(player.id, "st", index);
    }
  };

  // KILL PLAYER:
  this.kill = function (player, doer, info, silent, skipScore) {
    if (!player.dummy && !player.active) {
      return;
    }
    var didScore = false;
    if (!player.dummy) {
      player.active = false;
      if (player.isYou) {
        this.toggleAim(player, 0);
      }
      if (player.objInstances) {
        this.disposeMesh(player);
      }
    }
    if (io) {
      var strk = 0;
      var killData;
      player.deaths++;
      if (!game.mode.noStreaks) {
        player.deathStreak++;
      }
      if (player.lives && !game.waitTimers) {
        player.lives--;
        io.send(player.id, "lv", player.lives);
      }
      game.kills++;
      if (doer && doer != player) {
        if (!player.dummy) {
          doer.kills++;
        }
        if (!game.mode.noStreaks) {
          doer.streak++;
          doer.killStreak++;
          doer.deathStreak = 0;
          this.checkStreak(doer);
          if (doer.killStreak == 5) {
            strk = 5;
          } else {
            if (doer.killStreak == 10) {
              strk = 10;
            } else {
              if (doer.killStreak == 15) {
                strk = 15;
              } else {
                if (doer.killStreak == 20) {
                  strk = 20;
                } else {
                  if (doer.killStreak == 25) {
                    strk = 25;
                  } else {
                    if (doer.killStreak == 30) {
                      strk = 30;
                    }
                  }
                }
              }
            }
          }
          if (game.now - doer.lastKill >= config.feedTimer) {
            doer.streak = 0;
          }
        }
        doer.lastKill = game.now;
        if (!skipScore && game.config.killRewards && !game.mode.noKillRewards) {
          killData = KILLS.reward(this, doer, player, info, game);
          if (killData) {
            io.send(doer.id, "6", killData, info.headShot ? 1 : 0, doer.kills);
          }
          this.score(doer, KILLS.getScore(killData), true);
          didScore = true;
        }
        game.players.dropWeapon(player, true);
      }
      if (game.mode.onKill) {
        game.mode.onKill(game, player, doer);
      }
      if (!player.dummy) {
        for (var i = 0; i < this.list.length; ++i) {
          if (!game.mode.noAssists && player.dmgReceived[this.list[i].id] && doer != this.list[i] && player.dmgReceived[this.list[i].id].val >= config.assistMin && game.now - player.dmgReceived[this.list[i].id].time <= config.assistTime) {
            this.list[i].assists++;
            this.score(this.list[i], config.assistScore, true);
            io.send(this.list[i].id, "10");
            didScore = true;
          }
          if (this.list[i] == player) {
            io.send(player.id, "3", player.sid, player.deaths, doer ? doer.sid : 0, game.mode.killRes ? game.mode.killRes(doer) : [doer ? doer.loadout[doer.weaponIndex] : -1, killData ? KILLS.getScore(killData) : 0], silent);
          } else {
            io.send(this.list[i].id, "3", player.sid, player.deaths, doer ? doer.sid : 0, null, silent);
          }
        }
      }
      if (strk) {
        io.broadcast("game" + game.sid, "kst", doer.sid, strk);
      }
    }
    if (io && !didScore) {
      this.syncLeaders();
    }
  };

  // INDEX BY SID:
  this.indexBySid = function (sid) {
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].sid == sid) {
        return i;
      }
    }
    return -1;
  };

  // FIND BY SID:
  this.findBySid = function (sid) {
    for (var i = 0; i < this.list.length; ++i) {
      if (this.list[i].sid === sid) {
        return this.list[i];
      }
    }
    return null;
  };
};